import { useLocale, useTranslation as useTranslation$1 } from '@aviv-unified-frontend/runtime/i18n';
import { useRef, useMemo } from 'react';
import { SavedSearchNotificationChannel } from '@aviv-saved-search/types';

// src/Utils/helpers/endpoints.ts
var createLegacyEndpoint = (stage, brand, route = "") => {
  switch (brand) {
    case "sl":
      return `https://${stage === "live" ? "www" : stage}.seloger.com${route}`;
    case "imn":
      return `https://${stage === "live" ? "" : stage + "-"}api.immowelt.com${route}`;
    case "iwt":
      return `https://${stage === "live" ? "" : stage + "-"}api.immowelt.com${route}`;
    case "li":
      return `https://${stage === "live" ? "www" : stage}.logic-immo.com${route}`;
    default:
      return `https://${stage === "live" ? "" : stage + "-"}api.immowelt.com${route}`;
  }
};
var brandHostnames = {
  dev: {
    imn: "https://www.dev.immonet.de",
    iwt: "https://dev.immowelt.de",
    sl: "https://dev.seloger.com",
    slp: "https://dev.myselogerpro.com",
    li: "https://dev.logic-immo.com",
    iwb: "https://dev.immoweb.be",
    sln: "https://dev.selogerneuf.com",
    iwtat: "https://dev.immowelt.at"
  },
  preview: {
    imn: "https://www.preview.immonet.de",
    iwt: "https://preview.immowelt.de",
    sl: "https://preview.seloger.com",
    slp: "https://preview.myselogerpro.com",
    li: "https://preview.logic-immo.com",
    iwb: "https://preview.immoweb.be",
    sln: "https://preview.selogerneuf.com",
    iwtat: "https://preview.immowelt.at"
  },
  live: {
    imn: "https://www.immonet.de",
    iwt: "https://www.immowelt.de",
    sl: "https://www.seloger.com",
    slp: "https://myselogerpro.com",
    li: "https://www.logic-immo.com",
    iwb: "https://www.immoweb.be",
    sln: "https://www.selogerneuf.com",
    iwtat: "https://www.immowelt.at"
  }
};
var getBrandHostname = (stage, brand) => brandHostnames[stage][brand];

// src/Utils/locales/de/translation.json
var translation_default = {
  SavedSearch: {
    actions: {
      editAlertCTA: "Speichern"
    },
    notificationpopup: {
      title1: "Benachrichtigungseinstellungen"
    },
    searchresults: {
      bodycopy: "Weitere Treffer entdecken",
      cta: "Zur Suche"
    },
    warningfeedbackmessage: {
      bodycopy: "L\xF6sche einen alten Suchauftrag, um einen neuen zu erstellen",
      title: "Du kannst bis zu 10 Suchauftr\xE4ge speichern"
    }
  },
  SavedSearch_alertEdit_action1: "Suchkriterien bearbeiten",
  SavedSearch_alertEdit_action3: "Suchauftrag l\xF6schen",
  savedSearch: {
    actions: {
      alertTitle: "Titel des Suchauftrags",
      disabled: "Aus",
      editAlert: "Suchauftrag bearbeiten",
      enabled: "Ein",
      listings: "Treffer anzeigen",
      modalChange: "Benachrichtigungen \xE4ndern",
      modalDelete: "L\xF6schen",
      modalEdit: "Bearbeiten",
      resetChanges: "Alle l\xF6schen",
      update: "Speichern"
    },
    alert: {
      title: "Suchauftr\xE4ge"
    },
    alertActivated: {
      action: "Suchauftrag aktiviert"
    },
    alertAlertsTab: {
      action: "Suchauftr\xE4ge"
    },
    alertAppNotifications: {
      option: "Benachrichtige mich \xFCber neue Objekte"
    },
    alertContinue: {
      action: "Fortfahren"
    },
    alertCreate: {
      action: "Suchauftrag speichern",
      text: "Erhalte Benachrichtigungen, wenn ein neues Objekt deinen Suchkriterien entspricht"
    },
    alertDeletePopUp: {
      text: "Du hast die maximale Anzahl von Suchauftr\xE4gen erreicht. L\xF6sche mindestens einen, um fortzufahren.",
      title: "Suchauftrag l\xF6schen"
    },
    alertEdit: {
      title: "Meine Suchauftr\xE4ge bearbeiten"
    },
    alertEmail: {
      actionCreate: "Suche speichern",
      created: {
        action: "Treffer azeigen",
        text: "Du erh\xE4ltst ab sofort neue Vorschl\xE4ge an die folgende E-Mail-Adresse:",
        title: "Deine E-Mail-Benachrichtigungen wurden erfolgreich eingerichtet."
      },
      disclaimer: {
        link: "hier klicken.",
        text: "Aviv Germany GmbH verarbeitet Ihre Daten, um Ihre Anfrage zur Benachrichtigung \xFCber neue Immobilienanzeigen per E-Mail zu bearbeiten. Um mehr zu erfahren und Ihre Rechte auszu\xFCben, "
      },
      invalid: "Bitte geben Sie eine g\xFCtige E-Mail-Adresse ein",
      option: "E-Mail",
      text: "Gebe deine E-Mail-Adresse an, um personalisierte Immobilienanzeigen und eine Auswahl an Maklern zu erhalten"
    },
    alertEmptyState: {
      text: "Wir benachrichtigen dich, wenn neue Objekte deinen Suchkriterien entsprechen",
      title: "Keine Suchauftr\xE4ge vorhanden"
    },
    alertFavouritesTab: {
      action: "Wunschliste"
    },
    alertForceLogin: {
      promote: "Verwalte deine Suchauftr\xE4ge auf jedem Ger\xE4t.",
      text: "Suchauftr\xE4ge und Benachrichtigungseinstellungen verwalten",
      title: "Melde dich an, um deine Suchauftr\xE4ge zu verwalten"
    },
    alertInternetError: {
      text: "Schalte deine mobilen Daten ein oder stelle eine Verbindung zu einem WLAN-Netzwerk her",
      title: "Keine Internetverbindung"
    },
    alertInvalid: {
      text: "Ung\xFCltige Suchkriterien"
    },
    alertLoading: {
      title: "Suchauftr\xE4ge werden geladen"
    },
    alertResubscribe: {
      action: "Suche fortsetzen",
      link: "Erneut abonnieren",
      secondTitle: "Du kannst au\xDFerdem:",
      text: "Danke, dass du bei uns geblieben bist.",
      title: "Du hast dich wieder angemeldet."
    },
    alertRetry: {
      action: "Erneut versuchen"
    },
    alertSave: {
      action: "Suchauftrag speichern"
    },
    alertSee: {
      action: "Immobilien anzeigen"
    },
    alertSetup: {
      title: "Erhalte Benachrichtigungen zu neuen Objekten"
    },
    alertSignin: {
      action: "Anmelden "
    },
    alertSignup: {
      action: "Registrieren"
    },
    alertTechnicalError: {
      text: "Es gibt zurzeit ein paar Probleme. Bitte warte ein paar Minuten und versuche es erneut.",
      title: "Etwas ist schiefgelaufen"
    },
    alertUnsubscribe: {
      acknowledgement: "Vielen Dank f\xFCr dein Feedback",
      form: {
        submit: "Feedback senden"
      },
      radioGroup: {
        label: "Sag uns, wie wir besser werden k\xF6nnen"
      },
      title: "Du wurdest erfolgreich von {{alertName}} abgemeldet"
    },
    alertValidate: {
      action: "Best\xE4tigen"
    },
    alertsPaused: {
      text: "Alle Suchauftrag-Benachrichtigungen wurden deaktiviert. Du kannst sie jederzeit wieder aktivieren."
    },
    anonymousRegister: {
      action: "Anmelden",
      text: "Melden Sie sich an, um Ihre Suchauftr\xE4ge weiter zu bearbeiten.",
      title: "Anmelden und Vorteile nutzen"
    },
    cancel: {
      action: "Abbrechen"
    },
    card: {
      carousel: {
        title: "Unsere neuesten Immobilien f\xFCr dich"
      }
    },
    checkbox: {
      marketing: "Nein, ich m\xF6chte keine weiteren Informationen rund um mein Immobilienprojekt von {{brand}} per E-Mail erhalten.",
      partner: {
        firstText: "Ja, ich m\xF6chte weitere Informationen rund um mein Immobilienprojekt von",
        secondText: "Partnern per E-Mail erhalten. Widerruf jederzeit m\xF6glich."
      }
    },
    createAlertsByHitting: {
      text: "Du kannst einen neuen Suchauftrag \xFCber die Suchergebnisseite erstellen."
    },
    criterias: {
      area: {
        title: "Fl\xE4che"
      },
      common: {
        range: {
          label: {
            max: "Max",
            min: "Min"
          }
        }
      },
      context_switch: {
        commercial: "Gewerbe",
        residential: "Wohnen"
      },
      estate_subtype: {
        agriculture_forestry: {
          checkbox: {
            agriculture_company: "Landwirtschaftlicher Betrieb",
            farm_ranch: "Bauernhof",
            forestry: "Forstwirtschaft",
            gardening_orchard: "Gartenarbeit / Obstgarten",
            hunting_fishing: "Jagd und Fischerei",
            riding: "Reiterhof",
            winery: "Weingut"
          },
          title: "Objektart"
        },
        apartment: {
          checkbox: {
            loft: "Loft",
            multi_storey: "Mehrgeschosswohnung",
            penthouse: "Penthouse",
            studio: "Studio",
            terrace: "Terrassenwohnung"
          },
          title: "Wohnungstyp"
        },
        gastronomy_hotel: {
          checkbox: {
            cafe_bar_pub: "Caf\xE9 / Bar / Kneipe",
            club_discotheque: "Club / Diskothek",
            hotel_pension: "Hotel / Pension",
            restaurant: "Restaurant"
          },
          title: "Objektart"
        },
        house: {
          checkbox: {
            bungalow: "Bungalow",
            castle: "Schloss",
            chalet: "Chalet",
            farmhouse: "Bauernhaus",
            finca: "Finca",
            manor_house: "Herrenhaus",
            multi_family_house: "Mehrfamilienhaus",
            rustico: "Rustico",
            semidetached_house: "Doppelhaush\xE4lfte",
            single_family_house: "Einfamilienhaus",
            terrace_house: "Reihenhaus",
            town_house: "Stadthaus",
            villa: "Villa"
          },
          title: "Haustyp"
        },
        office: {
          checkbox: {
            atelier: "Atelier",
            coworking: "Coworking",
            living_and_commercial_building: "Wohn- und Gesch\xE4ftshaus",
            medical: "Praxis",
            office: "B\xFCro"
          },
          title: "Objektart"
        },
        parking: {
          checkbox: {
            carport: "Carport",
            duplex: "Doppelgarage",
            garage: "Garage",
            outside: "Au\xDFenstellplatz",
            underground_garage: "Tiefgarage",
            underground_parking_space: "Tiefgaragenstellplatz"
          },
          title: "Stellplatztyp"
        },
        plot: {
          checkbox: {
            commercial: "Gewerbliche Nutzung",
            leisure_facility: "Freizeit",
            living: "Wohnen"
          },
          title: "Grundst\xFCcksart"
        },
        storage_production: {
          checkbox: {
            garage_repair: "Werkstatt",
            logistic_center: "Logistik-Center",
            miscellaneous_storage: "Sonstige Lagerung",
            outdoor_space: "Au\xDFenfl\xE4che",
            production_hall: "Industriehalle",
            warehouse_hall: "Lagerhalle"
          },
          title: "Objektart"
        },
        trading: {
          checkbox: {
            kiosk: "Kiosk",
            sales_area: "Verkaufsfl\xE4che",
            shopping_centre: "Einkaufszentrum",
            showroom_space: "Ausstellungsfl\xE4che",
            store: "Laden Sie"
          },
          title: "Objektart"
        }
      },
      features: {
        checkbox: {
          attic_apartment: "Dachgeschoss-Wohnung",
          balcony_terrace: "Balkon / Terrasse",
          bathroom_with_bathtub: "Badezimmer mit Badewanne",
          bathroom_with_window: "Bad mit Fenster",
          built_in_kitchen: "Einbauk\xFCche",
          cellar: "Keller",
          certificate_of_eligibility_needed: "mit Wohnberechtigungsschein",
          elevator: "Aufzug",
          free_of_commission: "Provisionsfrei",
          furnished: "Vollst\xE4ndig m\xF6bliert",
          garden: "Garten",
          no_attic_apartment: "Kein Dachgeschoss",
          no_ground_floor: "Kein Erdgeschoss",
          parking_garage: "Parkplatz / Garage",
          pets_allowed: "Haustiere erlaubt",
          reduced_mobility_access: "Barrierefrei",
          unfurnished: "Unm\xF6bliert",
          vacant: "Frei / Nicht vermietet"
        },
        subtitle: {
          accessibility: "Erreichbarkeit",
          furnished_unfurnished: "M\xF6bliert/unm\xF6bliert",
          indoor: "Innenbereich",
          usage: "Verwendung"
        },
        title: {
          features_excluded: "Ausschlusskriterien",
          features_included: "Eigenschaften",
          foreclosure: "Zwangsversteigerung",
          new_builds: "Neubauprojekte",
          subsidizing_housing: "Wohnberechtigungsschein"
        }
      },
      floor: "Geschoss",
      floors: {
        checkbox: {
          ground_floor: "Erdgeschoss",
          no_ground_floor: "Kein Erdgeschoss",
          other_floors: "Andere Geschosse"
        }
      },
      living_area: {
        input_field: {
          surface_type: "m\xB2"
        },
        title: "Wohnfl\xE4che"
      },
      location: {
        circles: "{{placeName}} +{{radius}} {{radiusUnit}}",
        circles_prefixed: "in {{placeName}} +{{radius}} {{radiusUnit}}",
        places_one: "{{placeName}}",
        places_other: "{{placeName}} (+{{count}})",
        places_prefixed_one: "in {{placeName}}",
        places_prefixed_other: "in {{placeName}} (+{{count}})",
        places_prefixed_zero: "",
        polygons: "ihr pers\xF6nlicher Kartenbereich",
        polygons_prefixed: "in ihr pers\xF6nlicher Kartenbereich",
        travels: "{{duration}} min {{mode}} von {{placeName}}",
        travels_prefixed: "bei {{duration}} min {{mode}} von {{placeName}}"
      },
      plot_area: {
        input_field: {
          surface_type: "m\xB2"
        },
        title: "Grundst\xFCcksfl\xE4che"
      },
      project_type: {
        checkbox: {
          foreclosure_sale: "Zwangsversteigerung",
          investment: "Anlageobjekte",
          new_builds: "Neubauprojekte",
          resale: "Bestandsimmobilien",
          shared_flats: "Wohngemeinschaften",
          stock: "Lagerbestand",
          temporary_living: "Vor\xFCbergehendes Wohnen"
        },
        title: "Projekttyp"
      }
    },
    deleteAlertConfirmation: {
      feedback: {
        label: "Warum hast du diesen Suchauftrag gel\xF6scht ?",
        submit: "Feedback senden",
        success: "Vielen Dank f\xFCr dein Feedback!"
      },
      text: "Du wirst keine weiteren Benachrichtigungen f\xFCr neue Objekte, die diesen Suchkriterien entsprechen, erhalten.",
      title: "Bist du sicher, dass du diesen Suchauftrag l\xF6schen m\xF6chtest?"
    },
    distribution_type: {
      buy: "Kauf",
      compulsory_auction: "Zwangsversteigerung",
      rent: "Miete"
    },
    emailResubscribed: {
      action: "Weitersuchen",
      text: "Danke, dass du bei uns geblieben bist.",
      title: "Du hast die Benachrichtigungen f\xFCr deinen Suchauftrag wieder aktiviert."
    },
    enums: {
      distributionType: {
        BUY: "Kauf",
        BUY_AUCTION: "Kauf",
        BUY_AUCTION_prefixed: "zum Kauf",
        BUY_prefixed: "zum Kauf",
        COMPULSORY_AUCTION: "Zwangsversteigerung",
        COMPULSORY_AUCTION_prefixed: "zur Zwangsversteigerung",
        RENT: "Miete",
        RENT_prefixed: "zur Miete"
      },
      estateType: {
        AGRICULTURE_FORESTRY: "Land-/Forstwirtschaft",
        AGRICULTURE_FORESTRY_prefixed: "eine Land-/Forstwirtschaft",
        APARTMENT: "Wohnung",
        APARTMENT_prefixed: "eine Wohnung",
        BUILDING: "Geb\xE4ude",
        BUILDING_prefixed: "ein Geb\xE4ude",
        GASTRONOMY_HOTEL: "Gastronomie/Hotel",
        GASTRONOMY_HOTEL_prefixed: "eine Gastronomie/Hotel",
        HOUSE: "Haus",
        HOUSE_prefixed: "ein Haus",
        MISCELLANEOUS: "Sonstiges",
        MISCELLANEOUS_prefixed: "Sonstiges",
        OFFICE: "B\xFCro-/Praxisfl\xE4che",
        OFFICE_prefixed: "eine B\xFCro-/Praxisfl\xE4che",
        PARKING: "Parkplatz",
        PARKING_prefixed: "ein Parkplatz",
        PLOT: "Grundst\xFCck",
        PLOT_prefixed: "ein Grundst\xFCck",
        PROJECT: "Bauprojekt",
        PROJECT_prefixed: "ein Bauprojekt",
        SENIOR: "Seniorenwohnung",
        SENIOR_prefixed: "eine Seniorenwohnung",
        STORAGE_PRODUCTION: "Halle/Industriefl\xE4che",
        STORAGE_PRODUCTION_prefixed: "eine Halle/Industriefl\xE4che",
        TRADING: "Ladenfl\xE4che",
        TRADING_prefixed: "eine Ladenfl\xE4che"
      },
      travelMode: {
        BIKE: "Fahrrad",
        BIKE_prefixed: "mit dem Fahrrad",
        CAR: "Auto",
        CAR_prefixed: "mit dem Auto",
        TRANSIT: "\xD6PNV",
        TRANSIT_prefixed: "mit dem \xD6PNV",
        WALK: "zu Fu\xDF",
        WALK_prefixed: "zu Fu\xDF"
      }
    },
    errorCreate: {
      text: "Dein Suchauftrag konnte nicht gespeichert werden. Bitte versuche es sp\xE4ter noch einmal."
    },
    errorDelete: {
      text: "Dein Suchauftrag kann nicht gel\xF6scht werden."
    },
    errorPage: {
      action: "Zu den Suchauftr\xE4gen",
      text: "Der Link, dem Sie gefolgt sind, ist m\xF6glicherweise defekt, oder die Seite wurde entfernt.",
      title: "Diese Seite ist nicht verf\xFCgbar."
    },
    errorPageGeneric: {
      text: "Leider konnte diese Seite nicht geladen werden, bitte versuchen Sie es sp\xE4ter erneut.",
      title: "Es ist ein Fehler aufgetreten"
    },
    errorTechnicalRetry: {
      text: "Es ist ein technischer Fehler aufgetreten. Bitte versuche es sp\xE4ter noch einmal."
    },
    errorUpdate: {
      text: "Dein Suchauftrag kann nicht aktualisiert werden. Bitte versuche es sp\xE4ter noch einmal."
    },
    estate_type: {
      agriculture_forestry: "Land- / Forstwirtschaft",
      apartment: "Wohnung",
      gastronomy_hotel: "Gastronomie / Hotel",
      house: "Haus",
      house_apartment: "Haus oder Wohnung",
      investment_property: "Renditeobjekt",
      miscellaneous: "Sonstiges",
      office: "B\xFCro- / Praxisfl\xE4che",
      parking: "Parkplatz",
      plot: "Grundst\xFCck",
      project: "Projekt",
      shared_apartment: "Wohngemeinschaft",
      storage_production: "Halle / Industriefl\xE4che",
      temporary_living: "Wohnen auf Zeit",
      trading: "Ladenfl\xE4che"
    },
    frequencyEdit: {
      email: "E-Mail-Benachrichtigungen",
      frequency: {
        daily: "Einmal t\xE4glich",
        hourly: "Einmal st\xFCndlich",
        never: "Aus",
        realtime: "In Echtzeit",
        title: "H\xE4ufigkeit der Benachrichtigungen"
      },
      recommendation: {
        text: "Erhalte passende Alternativen zu deinen Suchkriterien",
        title: "Empfehlungen erhalten"
      },
      title: "Benachrichtigungen erhalten",
      trigger: "Benachrichtigungen"
    },
    geometry_location: {
      title: "pers\xF6nlicher Kartenausschnitt"
    },
    getAlerts: {
      action: "Suchauftrag speichern"
    },
    goBack: {
      action: "Zur\xFCck"
    },
    goToSearch: {
      action: "Zur Suche"
    },
    hint: {
      animatedHint: {
        text: "Erhalte die neuesten Treffer f\xFCr deine Suchkriterien",
        title: "Beschleunige deine Suche"
      },
      default: {
        text: "Benachrichtigungen aktivieren, um sofort \xFCber neue Objekte informiert zu werden, die deinen Suchkriterien entsprechen.",
        title: "Suchauftrag einrichten"
      },
      travel_time: {
        text: "Das Speichern Ihrer Suche ist jetzt m\xF6glich!",
        title: "Neue Funktion"
      }
    },
    hpMfe: {
      mvp: {
        blockText: "Sollen wir weitermachen?"
      },
      noMore: {
        firstAction: "Weitere Unterk\xFCnfte anzeigen",
        firstText: "Interessiert an weiteren Treffern?",
        secondAction: "Neue Suche starten",
        secondText: "Dann kannst du jetzt..."
      },
      seeMore: {
        action: "Weitere anzeigen",
        text: "{{number}} weitere Treffer f\xFCr dich"
      },
      text: "Neueste Treffer zu deinem Suchauftrag",
      title: "Ihre letzte gespeicherte Suche"
    },
    iconCriteria: {
      rooms: {
        text: "Zi."
      }
    },
    intermediaryMatchingMandate: {
      errors: {
        consent: "",
        email: "",
        phoneNumber: "",
        required: "",
        string: ""
      },
      informations: "",
      labels: {
        consent: "",
        email: "",
        message: "",
        name: "",
        phoneNumber: ""
      },
      legal: {
        text: {
          first: "",
          fourth: "",
          link: {
            first: "AVIV Group",
            second: "Datenschutzrichtlinie.",
            third: "Allgemeine Nutzungsbedingungen"
          },
          second: "",
          third: ""
        }
      },
      placeholders: {
        message: "",
        phoneNumber: ""
      },
      submit: "",
      success: "",
      suggestions: {
        text: "",
        title: ""
      }
    },
    loader_text: "Seite wird geladen",
    match: {
      type: {
        boost: "Boost",
        new: "Neues match"
      }
    },
    noAlertError: {
      text: "Gehe zur Suche und erg\xE4nze deine Suchkriterien ",
      title: "Erstelle deinen ersten Suchauftrag"
    },
    notificationHub: {
      notLoggedIn: {
        button: "Anmelden",
        text: "Behalte den \xDCberblick \xFCber deine gespeicherten Inserate und Suchanfragen.",
        title: "Melde dich an, um deine Benachrichtigungen zu sehen"
      },
      withoutContent: {
        button: "Zur Suche",
        text: "Entdecke Immobilien und lassen dich benachrichtigen, wenn neue Angebote zu deiner Suche passen.",
        title: "Benachrichtigungen aktivieren"
      }
    },
    notifications: {
      area: {
        draw: "Karte anzeigen",
        travelTime: "Fahrtzeitsuche {{count}} {{unit}} {{mode}}, {{city}}"
      },
      aria: {
        close: "Benachrichtigungszentrale schlie\xDFen",
        ssmui: "Verwalte deine Benachrichtigungen"
      },
      recommendations: "Empfehlungen",
      title: "Benachrichtigungen",
      tooltip: "Aktualisiere deine Einstellungen und erhalte alternative Empfehlungen f\xFCr deinen Suchauftrag"
    },
    pauseAllNotifications: {
      action: "Alle Benachrichtigungen deaktiviert."
    },
    preUser: {
      create: {
        text: "Gebe deine E-Mail-Adresse ein, um neue Angebote zu erhalten.",
        title: "Fast fertig..."
      },
      created: {
        register: "Account erstellen",
        skip: "\xDCberspringen",
        text: "Jetzt fehlt nur noch ein Schritt: Erstelle einen Account. So kannst du gespeicherten Suchen und Favoriten einfacher verwalten.",
        title: "Dein Suchauftrag wurde gespeichert"
      },
      error: {
        generic: "Erstelle ein Konto oder melde dich an, um diesen Suchauftrag zu speichern"
      },
      legal: {
        linkWording: {
          first: "Aviv Germany GmbH",
          second: "hier klicken",
          third: "Datenschutzerkl\xE4rung"
        },
        text: {
          first: "Um Ihr Konto zu erstellen und damit verbundene Services zu erm\xF6glichen, verarbeitet",
          second: "Ihre Daten.",
          third: "Weitere Informationen zu Ihren Rechten finden Sie in unserer"
        }
      }
    },
    resubscribe: {
      action: "Wieder aktivieren"
    },
    secondPage: {
      text: "Erhalte die neuesten Treffer, die deinen Suchkriterien entsprechen",
      title: "Beschleunige deine Suche mit einem Suchauftrag"
    },
    segmentationUnsub: {
      buttons: {
        continue: "Weitersuchen",
        manage: "Suchauftr\xE4ge verwalten"
      },
      text: {
        confirm: "Alle Suchauftr\xE4ge wurden deaktiviert.",
        landing: "M\xF6chtest du alle deine Suchauftr\xE4ge abbestelen?"
      },
      title: {
        confirm: "Du hast dich erfolgreich abgemeldet",
        landing: "Abbestellen"
      }
    },
    serpBanner: {
      text: "Erhalte die neuesten Treffer f\xFCr deine Suchkriterien",
      title: "Beschleunige deine Suche"
    },
    timeFormat: {
      day: "{{count}}t",
      hour: "{{count}}h",
      minute: "{{count}}mn",
      month: "{{count}}mo",
      week: ""
    },
    title: {
      circles: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) in {{placeName}} +{{radius}} {{radiusUnit}}",
      default: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed)",
      errors: {
        tooLarge: "Maximal 100 Zeichen erlaubt"
      },
      location: "{{estateTypes, list(type: disjunction)}} {{distributionType}} {{location}}",
      places: '{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) $t(savedSearch.criterias.location.places, { "context": "prefixed", "placeName":  "{{placeName}}", "count": {{placeCount}} })',
      polygons: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) in ihr pers\xF6nlicher Kartenbereich",
      travels: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) {{duration}} min {{mode}} von {{placeName}}"
    },
    unsubscribedEmailAlertSuccessfully: {
      title: 'Du hast die Benachrichtigungen f\xFCr deinen Suchauftrag "{{alertName}}" erfolgreich deaktiviert.'
    },
    youCanAlso: {
      title: "Du kannst sie au\xDFerdem:"
    }
  },
  savedSearch_alertClose_action: "Schlie\xDFen",
  savedSearch_alertCreated_action_text: "Zum Suchauftrag",
  savedSearch_alertCreated_text: "Neuer Suchauftrag erstellt",
  savedSearch_alertDelete_text: "Dein Suchauftrag wurde gel\xF6scht.",
  savedSearch_alertEdit_action2: "Benachrichtigungen bearbeiten",
  savedSearch_alertNotCreated_text: "Dieser Suchauftrag kann nicht erstellt werden.",
  savedSearch_alertUpdated_text: "Dein Suchauftrag wurde gespeichert.",
  savedSearch_buttonCard_title: "Echtzeit-Benachrichtigungen erhalten",
  savedSearch_deleteAlert_title: "Suchauftrag speichern",
  savedSearch_duplicateError_text: "Dieser Suchauftrag existiert bereits",
  savedSearch_duplicatePlaceId_text: "Leider gab es ein Problem mit dem gew\xE4hlten Suchbereich, bitte versuche es sp\xE4ter noch einmal.",
  savedSearch_errorSameSearchCriteria_text: "Du hast bereits einen Suchauftrag mit denselben Suchkriterien.",
  savedSearch_errorTechnical_text: "Es ist ein technischer Fehler aufgetreten.",
  savedSearch_invalidPolygonShape_text: "Der gezeichnete Kartenausschnitt ist ung\xFCltig. Linien k\xF6nnen nicht kreuzen.",
  savedSearch_invalidPolygon_text: "Es gibt einen Fehler mit dem ausgew\xE4hlten Suchergebnis, bitte passe den Kartenausschnitt an",
  savedSearch_locationTooLarge_text: "Suchgebiet zu gro\xDF, bitte reduziere die Anzahl der Standorte",
  savedSearch_locationTooSmall_text: "Der ausgew\xE4hlte Suchbereich ist zu klein.",
  savedSearch_niceJob_text: "Jetzt kannst du einen neuen Suchauftrag speichern.",
  savedSearch_niceJob_title: "Dein Suchauftrag wurde gel\xF6scht.",
  savedSearch_placeIDforbidden_text: "Der gew\xE4hlte Ortstyp kann nicht gespeichert werden, bitte w\xE4hle einen anderen Ort",
  savedSearch_polygonAlert_text: "Ein Suchaufrag kann leider aus einer Umkreissuche erstellt werden",
  "savedSearch_there\u2019sNoRoomLeft_text": "Du hast die maximale Anzahl von Suchauftr\xE4gen erreicht. L\xF6sche mindestens einen, um fortzufahren.",
  "savedSearch_there\u2019sNoRoomLeft_title": "Suchauftrag l\xF6schen"
};

// src/Utils/locales/en/translation.json
var translation_default2 = {
  SavedSearch: {
    actions: {
      editAlertCTA: "Save"
    },
    notificationpopup: {
      title1: "Notification settings"
    },
    searchresults: {
      bodycopy: "Find more listings on your search results page",
      cta: "Go to search"
    },
    warningfeedbackmessage: {
      bodycopy: "To save a new search remove at least one.",
      title: "You can have 10 saved searches"
    }
  },
  SavedSearch_alertEdit_action1: "Edit criteria",
  SavedSearch_alertEdit_action3: "Delete search",
  savedSearch: {
    actions: {
      alertTitle: "Name this saved search",
      disabled: "Never",
      editAlert: "Edit your saved search",
      enabled: "Enabled",
      listings: "See listings",
      modalChange: "Change notifications",
      modalDelete: "Delete search",
      modalEdit: "Edit",
      resetChanges: "Clear all",
      update: "Save"
    },
    alert: {
      title: "Saved searches"
    },
    alertActivated: {
      action: "Saved search enabled"
    },
    alertAlertsTab: {
      action: "Saved searches"
    },
    alertAppNotifications: {
      option: "Notify me of new listings:"
    },
    alertContinue: {
      action: "Continue"
    },
    alertCreate: {
      action: "Create a saved search",
      text: "Get notified when new listings match your criteria"
    },
    alertDeletePopUp: {
      text: "To save a new one please remove at least one.",
      title: "Delete a saved search"
    },
    alertEdit: {
      title: "Edit my saved search"
    },
    alertEmail: {
      actionCreate: "Create a saved search",
      created: {
        action: "See search results",
        text: "You will now receive new property suggestions to the following email address:",
        title: "Your email notification has been successfully created"
      },
      disclaimer: {
        link: "click here",
        text: "Digital Classifieds France processes your data in order to manage your request to alert new real estate advertisements by e-mail. To find out more and exercise your rights, "
      },
      invalid: "Please enter a valid email address",
      option: "Email",
      text: "Enter your email to receive all new personalized real estate ads and the selection of professionals."
    },
    alertEmptyState: {
      text: "Get notified when new listings match your criteria.",
      title: "No saved search"
    },
    alertFavouritesTab: {
      action: "Wishlist"
    },
    alertForceLogin: {
      promote: "Easily manage your saved searches from any device.",
      text: "Easily manage your saved searches and set up notification preferences.",
      title: "Log in or sign up to access"
    },
    alertInternetError: {
      text: "Turn on your mobile data or connect to a Wi-Fi network.",
      title: "No internet connection"
    },
    alertInvalid: {
      text: "Invalid search criteria"
    },
    alertLoading: {
      title: "Saved searches loading"
    },
    alertResubscribe: {
      action: "Continue searching",
      link: "Resubscribe",
      secondTitle: "You can also:",
      text: "Thanks for staying with us.",
      title: "You have resubscribed."
    },
    alertRetry: {
      action: "Retry"
    },
    alertSave: {
      action: "Create saved search"
    },
    alertSee: {
      action: "See listings"
    },
    alertSetup: {
      title: "Get notified of new listings"
    },
    alertSignin: {
      action: "Log in "
    },
    alertSignup: {
      action: "Sign up"
    },
    alertTechnicalError: {
      text: "We are experiencing some difficulties. Please wait a few minutes and try again.",
      title: "Something went wrong"
    },
    alertUnsubscribe: {
      acknowledgement: "Thank you for your feedback",
      form: {
        submit: "Submit feedback"
      },
      radioGroup: {
        label: "Tell us how we can do better"
      },
      title: "You have been successfully unsubscribed from {{alertName}}"
    },
    alertValidate: {
      action: "Validate"
    },
    alertsPaused: {
      text: "Notifications on all saved searches have been paused. You can reactivate them at anytime."
    },
    anonymousRegister: {
      action: "Register",
      text: "Only then will you be able to see all your saved searches.",
      title: "Please login"
    },
    cancel: {
      action: "Cancel"
    },
    card: {
      carousel: {
        title: "Our latest properties for you"
      }
    },
    checkbox: {
      marketing: "No, I don't want to receive more opportunities for my real estate project from {{brand}} by email.",
      partner: {
        firstText: "Yes, I accept to receive emails from partners",
        secondText: "to be supported in my real estate project."
      }
    },
    createAlertsByHitting: {
      text: "You can create a new saved search from the search result page."
    },
    criterias: {
      area: {
        title: "Area"
      },
      common: {
        range: {
          label: {
            max: "Max",
            min: "Min"
          }
        }
      },
      context_switch: {
        commercial: "For my business",
        residential: "For me"
      },
      estate_subtype: {
        agriculture_forestry: {
          checkbox: {
            agriculture_company: "Agriculture company",
            farm_ranch: "Farm / Ranch",
            forestry: "Forestry",
            gardening_orchard: "Gardening / Orchard",
            hunting_fishing: "Hunting / Fishing",
            riding: "Riding",
            winery: "Winery"
          },
          title: "Type of estate"
        },
        apartment: {
          checkbox: {
            loft: "Loft",
            multi_storey: "Multi Storey",
            penthouse: "Penthouse",
            studio: "Studio",
            terrace: "Terrace"
          },
          title: "Type of apartment"
        },
        gastronomy_hotel: {
          checkbox: {
            cafe_bar_pub: "Caf\xE9 / Bar / Pub",
            club_discotheque: "Club / Discotheque",
            hotel_pension: "Hotel / Pension",
            restaurant: "Restaurant"
          },
          title: "Type of estate"
        },
        house: {
          checkbox: {
            bungalow: "Bungalow",
            castle: "Castle",
            chalet: "Chalet",
            farmhouse: "Farmhouse",
            finca: "Finca",
            manor_house: "Manor house",
            multi_family_house: "Multi family house",
            rustico: "Rustico",
            semidetached_house: "Semidetached house",
            single_family_house: "Single family house",
            terrace_house: "Terrace house",
            town_house: "Town house",
            villa: "Villa"
          },
          title: "Type of house"
        },
        office: {
          checkbox: {
            atelier: "Atelier",
            coworking: "Coworking",
            living_and_commercial_building: "Living and commercial building",
            medical: "Medical",
            office: "Office"
          },
          title: "Type of office"
        },
        parking: {
          checkbox: {
            carport: "Carport",
            duplex: "Duplex",
            garage: "Garage",
            outside: "Outside parking",
            underground_garage: "Underground garage",
            underground_parking_space: "Underground parking"
          },
          title: "Type of parking"
        },
        plot: {
          checkbox: {
            commercial: "Commercial",
            leisure_facility: "Leisure facility",
            living: "Living"
          },
          title: "Type of plot"
        },
        storage_production: {
          checkbox: {
            garage_repair: "Garage / Repair",
            logistic_center: "Logistic Center",
            miscellaneous_storage: "Miscellaneous storage",
            outdoor_space: "Outdoor space",
            production_hall: "Production hall",
            warehouse_hall: "Warehouse hall"
          },
          title: "Type of estate"
        },
        trading: {
          checkbox: {
            kiosk: "Kiosk",
            sales_area: "Sales area",
            shopping_centre: "Shopping centre",
            showroom_space: "Showroom space",
            store: "Store"
          },
          title: "Type of shop"
        }
      },
      features: {
        checkbox: {
          attic_apartment: "Attic apartment",
          balcony_terrace: "Balcony / Terrace",
          bathroom_with_bathtub: "Bathroom with bathtub",
          bathroom_with_window: "Bathroom with window",
          built_in_kitchen: "Built-in kitchen",
          cellar: "Cellar",
          certificate_of_eligibility_needed: "certificate of eligibility required",
          elevator: "Elevator",
          free_of_commission: "Free of commission",
          furnished: "Fully furnished",
          garden: "Garden",
          no_attic_apartment: "No attic apartment",
          no_ground_floor: "No ground floor",
          parking_garage: "Parking / Garage",
          pets_allowed: "Pets allowed",
          reduced_mobility_access: "Reduced-mobility access",
          unfurnished: "Unfurnished",
          vacant: "Vacant / Not rented"
        },
        subtitle: {
          accessibility: "Accessibility",
          furnished_unfurnished: "Furnished / Unfurnished",
          indoor: "Indoor",
          usage: "Usage"
        },
        title: {
          features_excluded: "Features to exclude",
          features_included: "Features",
          foreclosure: "Foreclosure sale",
          new_builds: "New builds",
          subsidizing_housing: "Subsidizing housing"
        }
      },
      floor: "Floor",
      floors: {
        checkbox: {
          ground_floor: "Ground floor",
          no_ground_floor: "No ground floor",
          other_floors: "Other floors"
        }
      },
      living_area: {
        input_field: {
          surface_type: "m\xB2"
        },
        title: "Living area"
      },
      location: {
        circles: "{{placeName}} +{{radius}} {{radiusUnit}}",
        circles_prefixed: "in {{placeName}} +{{radius}} {{radiusUnit}}",
        places_one: "{{placeName}}",
        places_other: "{{placeName}} (+{{count}})",
        places_prefixed_one: "in {{placeName}}",
        places_prefixed_other: "in {{placeName}} (+{{count}})",
        places_prefixed_zero: "",
        polygons: "your personal map area",
        polygons_prefixed: "in your personal map area",
        travels: "{{duration}} min {{mode}} from {{placeName}}",
        travels_prefixed: "at {{duration}} min {{mode}} from {{placeName}}"
      },
      plot_area: {
        input_field: {
          surface_type: "m\xB2"
        },
        title: "Plot area"
      },
      project_type: {
        checkbox: {
          foreclosure_sale: "Foreclosure sale",
          investment: "Investment",
          new_builds: "New builds",
          resale: "Resale",
          shared_flats: "Shared flats",
          stock: "Stock",
          temporary_living: "Temporary living"
        },
        title: "Project type"
      }
    },
    deleteAlertConfirmation: {
      feedback: {
        label: "Why did you delete this saved search ?",
        submit: "Submit feedback",
        success: "Thank you for your feedback."
      },
      text: "You will no longer get notified of new listings matching this criteria.",
      title: "Are you sure you want to delete this search?"
    },
    distribution_type: {
      buy: "Buy",
      compulsory_auction: "Compulsory auction",
      rent: "Rent"
    },
    emailResubscribed: {
      action: "Continue searching",
      text: "Thanks for staying with us.",
      title: "You have resubscribed."
    },
    enums: {
      distributionType: {
        BUY: "buy",
        BUY_AUCTION: "buy",
        BUY_AUCTION_prefixed: "to buy",
        BUY_prefixed: "to buy",
        COMPULSORY_AUCTION: "compulsory auction",
        COMPULSORY_AUCTION_prefixed: "for compulsory auction",
        RENT: "rent",
        RENT_prefixed: "to rent"
      },
      estateType: {
        AGRICULTURE_FORESTRY: "Agriculture / Forestry",
        AGRICULTURE_FORESTRY_prefixed: "an Agriculture / Forestry",
        APARTMENT: "Apartment",
        APARTMENT_prefixed: "an Apartment",
        BUILDING: "Building",
        BUILDING_prefixed: "a Building",
        GASTRONOMY_HOTEL: "Gastronomy / Hotel",
        GASTRONOMY_HOTEL_prefixed: "a Gastronomy / Hotel",
        HOUSE: "House",
        HOUSE_prefixed: "a House",
        MISCELLANEOUS: "Miscellaneous",
        MISCELLANEOUS_prefixed: "Miscellaneous",
        OFFICE: "Office",
        OFFICE_prefixed: "an Office",
        PARKING: "Parking",
        PARKING_prefixed: "a Parking",
        PLOT: "Plot of land",
        PLOT_prefixed: "a Plot of land",
        PROJECT: "Project",
        PROJECT_prefixed: "a Project",
        SENIOR: "Senior apartment",
        SENIOR_prefixed: "a Senior apartment",
        STORAGE_PRODUCTION: "Storage / Production",
        STORAGE_PRODUCTION_prefixed: "a Storage / Production",
        TRADING: "Trading Area",
        TRADING_prefixed: "a Trading Area"
      },
      travelMode: {
        BIKE: "biking",
        BIKE_prefixed: "by biking",
        CAR: "car",
        CAR_prefixed: "by car",
        TRANSIT: "public transport",
        TRANSIT_prefixed: "by public transport",
        WALK: "walking",
        WALK_prefixed: "by walking"
      }
    },
    errorCreate: {
      text: "We were not able to create this saved search. Try again later."
    },
    errorDelete: {
      text: "We can't delete this saved search."
    },
    errorPage: {
      action: "Go to saved searches",
      text: "The link you followed may be broken, or the page may have been removed.",
      title: "This page isn\u2019t available"
    },
    errorPageGeneric: {
      text: "The page is not available. Please try again later.",
      title: "An error has occured"
    },
    errorTechnicalRetry: {
      text: "A technical error has occured. Try again later."
    },
    errorUpdate: {
      text: "We can't update this saved search. Try again later."
    },
    estate_type: {
      agriculture_forestry: "Agriculture / Forestry",
      apartment: "Apartment",
      gastronomy_hotel: "Gastronomy / Hotel",
      house: "House",
      house_apartment: "House / Apartment",
      investment_property: "Investment property",
      miscellaneous: "Miscellaneous",
      office: "Office",
      parking: "Parking",
      plot: "Plot of land",
      project: "Project",
      shared_apartment: "Shared apartment",
      storage_production: "Storage / Production",
      temporary_living: "Temporary living",
      trading: "Shop"
    },
    frequencyEdit: {
      email: "Email notifications",
      frequency: {
        daily: "Once a day",
        hourly: "Once per hour",
        never: "Never",
        realtime: "In real time",
        title: "Notifications frequency"
      },
      recommendation: {
        text: "Notify me of listings that nearly match my criteria",
        title: "Get recommendations "
      },
      title: "Saved search settings",
      trigger: "Notifications"
    },
    geometry_location: {
      title: "personal map area"
    },
    getAlerts: {
      action: "Create saved search"
    },
    goBack: {
      action: "Back"
    },
    goToSearch: {
      action: "Get started"
    },
    hint: {
      animatedHint: {
        text: "Get notified when new listings match your criteria.",
        title: "Track your search"
      },
      default: {
        text: "Get notified when new listings match your criteria.",
        title: "Track this search"
      },
      travel_time: {
        text: "Saving your search is now possible!",
        title: "New feature"
      }
    },
    hpMfe: {
      mvp: {
        blockText: "Shall we continue ?"
      },
      noMore: {
        firstAction: "See more properties",
        firstText: "That's all for now !",
        secondAction: "Start a new search",
        secondText: "Now you can..."
      },
      seeMore: {
        action: "See more properties",
        text: "{{number}} more properties in the selection"
      },
      text: "Latest matches based on your saved search",
      title: "Latest match based on your saved search"
    },
    iconCriteria: {
      rooms: {
        text: "ro"
      }
    },
    intermediaryMatchingMandate: {
      errors: {
        consent: "Without your consent, we cannot transmit your contact details to a selection of real estate agencies to assist you in your real estate project.",
        email: "Email is not valid",
        phoneNumber: "Phone number format is not valid",
        required: "{{field}} is required",
        string: "Wrong format"
      },
      informations: "By sending the request, you accept the Immowelt service. You will receive information based on the data you entered, the services used and the purpose of our business. You can object to this service anytime at datenschutz@immowelt.de. Further information can be found in the DataProtection policy.",
      labels: {
        consent: "I agree that my data are sent to a selection of real estate agencies proposing properties matching my saved search, who could contact me by email or phone to helping me with my property project.",
        email: "Email",
        message: "Your message",
        name: "Name",
        phoneNumber: "Phone number"
      },
      legal: {
        text: {
          first: "{{upperLocal}} - Digital Classifieds {{country}} processes your data in order to transmit it to the indicated advertiser. In this context, we will transmit this data to our entities",
          fourth: "apply.",
          link: {
            first: "AVIV Group",
            second: "Privacy Policy.",
            third: "General Conditions of Use"
          },
          second: "and our external service providers. You can withdraw your consent to the processing of optional data at any time. For more information about your rights and your data, see our",
          third: 'By clicking on "Confirm my request", our'
        }
      },
      placeholders: {
        message: "Provide details to help our experts understand exactly what you\u2019re looking for.",
        phoneNumber: "+33 XXX XXX XXX"
      },
      submit: "Confirm my request",
      success: "Your contact request has been sent successfully.",
      suggestions: {
        text: "Receive direct proposals from trusted agents including unpublished listings tailored to your preferences.",
        title: "Get property suggestions from agents"
      }
    },
    loader_text: "Page is loading",
    match: {
      type: {
        boost: "Boost",
        new: "New match"
      }
    },
    noAlertError: {
      text: "Go to the search page and start entering your criteria.",
      title: "Set up your first saved search"
    },
    notificationHub: {
      notLoggedIn: {
        button: "Sign-in",
        text: "Keep track of your saved listings and searches.",
        title: "Sign in to see your notifications"
      },
      withoutContent: {
        button: "Go to search",
        text: "Explore properties and get notified when new listings match your search.",
        title: "Start getting notifications"
      }
    },
    notifications: {
      area: {
        draw: "Map area",
        travelTime: "Commute {{count}} {{unit}} {{mode}}, {{city}}"
      },
      aria: {
        close: "Close notifications sidebar",
        ssmui: "Manage your notifications"
      },
      recommendations: "Recommendations",
      title: "Notifications",
      tooltip: "Update your notification settings and get alternative properties based on your saved search"
    },
    pauseAllNotifications: {
      action: "Pause all notifications"
    },
    preUser: {
      create: {
        text: "Enter your email to receive new listings.",
        title: "Almost done..."
      },
      created: {
        register: "Create account",
        skip: "Skip",
        text: "You now have one step left to create an account. This will allow you to manage your saved searches and favorites more easily.",
        title: "Your email notification is set"
      },
      error: {
        generic: "Create an account or log in to create this saved search."
      },
      legal: {
        linkWording: {
          first: "AVIV Group",
          second: "clicking here",
          third: "Privacy Policy"
        },
        text: {
          first: "This data may be transmitted to companies in the",
          second: "to which we belong. To exercise your rights over your data (access, rectification, erasure, opposition, portability, and limitation), contact us at this address: Digital Classifieds France - 2-8 rue des Italiens 75009 Paris or by",
          third: "For more information, see our"
        }
      }
    },
    resubscribe: {
      action: "Resubscribe"
    },
    secondPage: {
      text: "Get the latest listings that match your criteria.",
      title: "Create saved search notifications to find your dream property."
    },
    segmentationUnsub: {
      buttons: {
        continue: "Continue searching",
        manage: "Manage your saved searches"
      },
      text: {
        confirm: "All of your saved searches have been disabled",
        landing: "You will be unsubscribed from all your saved searches"
      },
      title: {
        confirm: "You have successfully unsubscribed",
        landing: "Unsubscribe"
      }
    },
    serpBanner: {
      text: "Get notified when new listings match your criteria.",
      title: "Track your search"
    },
    timeFormat: {
      day: "{{count}}d",
      hour: "{{count}}h",
      minute: "{{count}}mn",
      month: "{{count}}mo",
      week: "{{count}}w"
    },
    title: {
      circles: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) in {{placeName}} +{{radius}} {{radiusUnit}}",
      default: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed)",
      errors: {
        tooLarge: "Maximum 100 characters allowed"
      },
      location: "{{estateTypes, list(type: disjunction)}} {{distributionType}} {{location}}",
      places: '{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) $t(savedSearch.criterias.location.places, { "context": "prefixed", "placeName":  "{{placeName}}", "count": {{placeCount}} })',
      polygons: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) in your personal map area",
      travels: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) {{duration}} min {{mode}} from {{placeName}}"
    },
    unsubscribedEmailAlertSuccessfully: {
      title: "You have been successfully unsubscribed from {{alertName}}."
    },
    youCanAlso: {
      title: "You can also:"
    }
  },
  savedSearch_alertClose_action: "Close",
  savedSearch_alertCreated_action_text: "See my searches",
  savedSearch_alertCreated_text: "New saved search created.",
  savedSearch_alertDelete_text: "Your saved search has been deleted.",
  savedSearch_alertEdit_action2: "Change notifications",
  savedSearch_alertNotCreated_text: "We can't create this saved search.",
  savedSearch_alertUpdated_text: "New saved search created.",
  savedSearch_buttonCard_title: "Receive notifications in real time",
  savedSearch_deleteAlert_title: "Create a saved search",
  savedSearch_duplicateError_text: "You have already saved this search",
  savedSearch_duplicatePlaceId_text: "There is an issue with your selected location, pelase try again later",
  savedSearch_errorSameSearchCriteria_text: "You already have a saved search with the same criteria.",
  savedSearch_errorTechnical_text: "A technical error has occured.",
  savedSearch_invalidPolygonShape_text: "The drawn map area is not valid. Lines may not cross.",
  savedSearch_invalidPolygon_text: "There was an error with your search area, please adjust your map area",
  savedSearch_locationTooLarge_text: "Search area too large, please reduce number of locations",
  savedSearch_locationTooSmall_text: "The selected search area is too small",
  savedSearch_niceJob_text: "Now you can create a new saved search.",
  savedSearch_niceJob_title: "Your saved search has been deleted",
  savedSearch_placeIDforbidden_text: "Your selected place type is not supported, please choose a different value",
  savedSearch_polygonAlert_text: "We can't create a saved search from this radius search",
  "savedSearch_there\u2019sNoRoomLeft_text": "To save a new one please remove at least one.",
  "savedSearch_there\u2019sNoRoomLeft_title": "Delete a saved search"
};

// src/Utils/locales/fr/translation.json
var translation_default3 = {
  SavedSearch: {
    actions: {
      editAlertCTA: "Sauvegarder"
    },
    notificationpopup: {
      title1: "Notifications"
    },
    searchresults: {
      bodycopy: "D\xE9couvrez plus d'annonces sur votre page de r\xE9sultats de recherche.",
      cta: "Revenir \xE0 la recherche"
    },
    warningfeedbackmessage: {
      bodycopy: "Pour sauvegarder une nouvelle recherche, supprimez-en au moins une.",
      title: "Vous pouvez avoir 10 recherches sauvegard\xE9es"
    }
  },
  SavedSearch_alertEdit_action1: "Modifier les crit\xE8res",
  SavedSearch_alertEdit_action3: "Supprimer ma recherche",
  savedSearch: {
    actions: {
      alertTitle: "Titre",
      disabled: "Jamais",
      editAlert: "Modifiez votre recherche",
      enabled: "Activ\xE9e",
      listings: "Voir les annonces",
      modalChange: "Modifier les notifications",
      modalDelete: "Supprimer",
      modalEdit: "Modifier",
      resetChanges: "R\xE9initialiser",
      update: "Mettre \xE0 jour"
    },
    alert: {
      title: "Recherches sauvegard\xE9es"
    },
    alertActivated: {
      action: "Recherche sauvegard\xE9e"
    },
    alertAlertsTab: {
      action: "Recherches"
    },
    alertAppNotifications: {
      option: "Recevoir les derni\xE8res annonces par :"
    },
    alertContinue: {
      action: "Continuer"
    },
    alertCreate: {
      action: "Sauvegardez une recherche",
      text: "Soyez inform\xE9 d\xE8s qu'un nouveau bien correspond \xE0 vos crit\xE8res"
    },
    alertDeletePopUp: {
      text: "Pour sauvegarder une nouvelle recherche, supprimez-en au moins une.",
      title: "Supprimez une recherche sauvegard\xE9e"
    },
    alertEdit: {
      title: "Modifier ma recherche sauvegard\xE9e"
    },
    alertEmail: {
      actionCreate: "Sauvegarder ma recherche",
      created: {
        action: "Voir les r\xE9sultats de la recherche",
        text: "Vous recevrez d\xE9sormais de nouvelles suggestions de propri\xE9t\xE9s \xE0 l'adresse e-mail suivante :",
        title: "Votre notification par e-mail a \xE9t\xE9 activ\xE9e"
      },
      disclaimer: {
        link: "cliquez ici",
        text: "Digital Classifieds France traite vos donn\xE9es afin de g\xE9rer votre demande de notification de nouvelles annonces immobili\xE8res par e-mail. Pour en savoir plus et exercer vos droits, "
      },
      invalid: "Vous devez entrer une adresse e-mail valide",
      option: "E-mail",
      text: "Entrez votre email pour recevoir les annonces immobili\xE8res qui correspondent \xE0 votre recherche, ainsi que la s\xE9lection de nos professionnels."
    },
    alertEmptyState: {
      text: "Recevez imm\xE9diatement les nouveaux biens correspondant \xE0 vos crit\xE8res.",
      title: "Aucune recherche sauvegard\xE9e"
    },
    alertFavouritesTab: {
      action: "Favoris"
    },
    alertForceLogin: {
      promote: "G\xE9rez vos recherches sauvegard\xE9es depuis n'importe quel appareil.",
      text: "G\xE9rez vos recherches sauvegard\xE9es en toute simplicit\xE9.",
      title: "Connectez-vous ou cr\xE9ez un compte pour acc\xE9der \xE0 vos recherches"
    },
    alertInternetError: {
      text: "Activez vos donn\xE9es mobiles ou connectez-vous \xE0 un r\xE9seau Wi-Fi.",
      title: "Aucune connexion internet"
    },
    alertInvalid: {
      text: "Crit\xE8res de recherche invalides"
    },
    alertLoading: {
      title: "Chargement de vos recherches sauvegard\xE9es"
    },
    alertResubscribe: {
      action: "Retourner \xE0 la recherche",
      link: "Se r\xE9abonner",
      secondTitle: "Vous pouvez \xE9galement :",
      text: "Merci de rester avec nous.",
      title: "Vous vous \xEAtes r\xE9abonn\xE9."
    },
    alertRetry: {
      action: "R\xE9essayer"
    },
    alertSave: {
      action: "Sauvegarder une recherche"
    },
    alertSee: {
      action: "Voir les annonces"
    },
    alertSetup: {
      title: "Soyez inform\xE9 des nouvelles annonces"
    },
    alertSignin: {
      action: "Se connecter"
    },
    alertSignup: {
      action: "S'inscrire"
    },
    alertTechnicalError: {
      text: "Une erreur technique est survenue. R\xE9essayez plus tard.",
      title: "Une erreur s'est produite"
    },
    alertUnsubscribe: {
      acknowledgement: "Merci pour votre retour",
      form: {
        submit: "Soumettre"
      },
      radioGroup: {
        label: "Dites-nous comment nous pouvons nous am\xE9liorer"
      },
      title: "Vous avez \xE9t\xE9 d\xE9sabonn\xE9 avec succ\xE8s de l'alerte {{alertName}}"
    },
    alertValidate: {
      action: "Valider"
    },
    alertsPaused: {
      text: "Les notifications pour vos recherches sauvegard\xE9es ont \xE9t\xE9 d\xE9sactiv\xE9es. Vous pouvez les r\xE9activer d\xE8s que vous le souhaitez."
    },
    anonymousRegister: {
      action: "S\u2019inscrire",
      text: "Ce n'est qu'alors que vous pourrez voir toutes vos recherches enregistr\xE9es.",
      title: "Veuillez vous connecter"
    },
    cancel: {
      action: "Annuler"
    },
    card: {
      carousel: {
        title: "Nos derni\xE8res annonces pour vous"
      }
    },
    checkbox: {
      marketing: "Non, je ne souhaite pas recevoir d'autres opportunit\xE9s pour mon projet immobilier de la part de {{brand}} par email.",
      partner: {
        firstText: "Oui, je souhaite recevoir des communications email de la part des partenaires de",
        secondText: "pour m\u2019aider dans mon projet immobilier."
      }
    },
    createAlertsByHitting: {
      text: "Vous pouvez sauvegarder une nouvelle recherche depuis la page des r\xE9sultats de recherche."
    },
    criterias: {
      area: {
        title: "Surface"
      },
      common: {
        range: {
          label: {
            max: "Max",
            min: "Min"
          }
        }
      },
      context_switch: {
        commercial: "Pour mon entreprise",
        residential: "Pour moi"
      },
      estate_subtype: {
        agriculture_forestry: {
          checkbox: {
            agriculture_company: "Entreprise agricole",
            farm_ranch: "Ferme / Ranch",
            forestry: "For\xEAts",
            gardening_orchard: "Jardinage / Verger",
            hunting_fishing: "Chasse / P\xEAche",
            riding: "\xC9questre",
            winery: "Vignobles"
          },
          title: "Type de propri\xE9t\xE9"
        },
        apartment: {
          checkbox: {
            loft: "Loft",
            multi_storey: "Plusieurs \xE9tages",
            penthouse: "Penthouse",
            studio: "Studio",
            terrace: "Terrasse"
          },
          title: "Type d'immobilier"
        },
        gastronomy_hotel: {
          checkbox: {
            cafe_bar_pub: "Caf\xE9 / Bar / Pub",
            club_discotheque: "Club / Discoth\xE8que",
            hotel_pension: "H\xF4tel / Pension",
            restaurant: "Restaurant"
          },
          title: "Type de propri\xE9t\xE9"
        },
        house: {
          checkbox: {
            bungalow: "Bungalow",
            castle: "Ch\xE2teau",
            chalet: "Chalet",
            farmhouse: "Ferme",
            finca: "Finca",
            manor_house: "Manoir",
            multi_family_house: "Maison multifamiliale",
            rustico: "Rustico",
            semidetached_house: "Maison jumel\xE9e",
            single_family_house: "Maison individuelle",
            terrace_house: "Maison en terrasse",
            town_house: "Maison de ville",
            villa: "Villa"
          },
          title: "Type de maison"
        },
        office: {
          checkbox: {
            atelier: "Atelier",
            coworking: "Coworking",
            living_and_commercial_building: "Immeuble d'habitation et commercial",
            medical: "M\xE9dical",
            office: "Bureau"
          },
          title: "Type de bureau"
        },
        parking: {
          checkbox: {
            carport: "Abri de voiture",
            duplex: "Garage double",
            garage: "Garage",
            outside: "Parking ext\xE9rieur",
            underground_garage: "Garage souterrain",
            underground_parking_space: "Parking souterrain"
          },
          title: "Type de parking"
        },
        plot: {
          checkbox: {
            commercial: "Commercial",
            leisure_facility: "Centre de loisirs",
            living: "R\xE9sidentiel"
          },
          title: "Type de parcelle"
        },
        storage_production: {
          checkbox: {
            garage_repair: "Garage / R\xE9paration",
            logistic_center: "Centre logistique",
            miscellaneous_storage: "Stockage divers",
            outdoor_space: "Espace ext\xE9rieur",
            production_hall: "Salle de production",
            warehouse_hall: "Entrep\xF4t"
          },
          title: "Type de propri\xE9t\xE9"
        },
        trading: {
          checkbox: {
            kiosk: "Kiosque",
            sales_area: "Espace de vente",
            shopping_centre: "Centre commercial",
            showroom_space: "Espace d'exposition",
            store: "Magasin"
          },
          title: "Type de magasin"
        }
      },
      features: {
        checkbox: {
          attic_apartment: "Appartement au dernier \xE9tage",
          balcony_terrace: "Balcon / Terrasse",
          bathroom_with_bathtub: "Salle de bain avec baignoire",
          bathroom_with_window: "Salle de bain avec fen\xEAtre",
          built_in_kitchen: "Cuisine int\xE9gr\xE9e",
          cellar: "Cave",
          certificate_of_eligibility_needed: "Un certificat d'\xE9ligibilit\xE9 est requis",
          elevator: "Ascenseur",
          free_of_commission: "Sans commission",
          furnished: "Enti\xE8rement meubl\xE9",
          garden: "Jardin",
          no_attic_apartment: "Pas d'appartement au dernier \xE9tage",
          no_ground_floor: "Pas de rez-de-chauss\xE9e",
          parking_garage: "Parking / Garage",
          pets_allowed: "Animaux autoris\xE9s",
          reduced_mobility_access: "Acc\xE8s \xE0 mobilit\xE9 r\xE9duite",
          unfurnished: "Non meubl\xE9",
          vacant: "Vacant / Non lou\xE9"
        },
        subtitle: {
          accessibility: "Accessibilit\xE9",
          furnished_unfurnished: "Meubl\xE9 / Non meubl\xE9",
          indoor: "Int\xE9rieur",
          usage: "Utilisation"
        },
        title: {
          features_excluded: "Caract\xE9ristiques \xE0 exclure",
          features_included: "Caract\xE9ristiques",
          foreclosure: "Vente sur saisie",
          new_builds: "Nouvelles constructions",
          subsidizing_housing: "Logement subventionn\xE9"
        }
      },
      floor: "Etage",
      floors: {
        checkbox: {
          ground_floor: "Rez-de-chauss\xE9e",
          no_ground_floor: "Pas de rez-de-chauss\xE9e",
          other_floors: "Autres \xE9tages"
        }
      },
      living_area: {
        input_field: {
          surface_type: "m\xB2"
        },
        title: "Surface"
      },
      location: {
        circles: "{{placeName}} +{{radius}} {{radiusUnit}}",
        circles_prefixed: "autour de {{placeName}} +{{radius}} {{radiusUnit}}",
        places_one: "{{placeName}}",
        places_other: "{{placeName}} (+{{count}})",
        places_prefixed_one: "\xE0 {{placeName}}",
        places_prefixed_other: "\xE0 {{placeName}} (+{{count}})",
        places_prefixed_zero: "",
        polygons: "votre zone personnalis\xE9e",
        polygons_prefixed: "dans votre zone personnalis\xE9e",
        travels: "{{duration}} min {{mode}} de {{placeName}}",
        travels_prefixed: "\xE0 {{duration}} min {{mode}} de {{placeName}}"
      },
      plot_area: {
        input_field: {
          surface_type: "m\xB2"
        },
        title: "Surface de la parcelle"
      },
      project_type: {
        checkbox: {
          foreclosure_sale: "Vente sur saisie",
          investment: "Investissement",
          new_builds: "Nouvelles constructions",
          resale: "Ancien",
          shared_flats: "Appartements partag\xE9s",
          stock: "Stock",
          temporary_living: "Logement temporaire"
        },
        title: "Type de projet"
      }
    },
    deleteAlertConfirmation: {
      feedback: {
        label: "Pourquoi avez-vous supprim\xE9 cette recherche ? ",
        submit: "Envoyer",
        success: "Envoy\xE9 ! Merci pour votre retour."
      },
      text: "Vous ne recevrez plus d'annonces correspondantes \xE0 ces crit\xE8res de recherche.",
      title: "Voulez-vous vraiment supprimer cette recherche ?"
    },
    distribution_type: {
      buy: "Acheter",
      compulsory_auction: "Ench\xE8res obligatoires",
      rent: "Louer"
    },
    emailResubscribed: {
      action: "Continuer la recherche",
      text: "Merci d'\xEAtre rest\xE9 avec nous.",
      title: "Vous vous \xEAtes r\xE9abonn\xE9."
    },
    enums: {
      distributionType: {
        BUY: "acheter",
        BUY_AUCTION: "acheter aux ench\xE8res",
        BUY_AUCTION_prefixed: "pour acheter aux ench\xE8res",
        BUY_prefixed: "\xE0 acheter",
        COMPULSORY_AUCTION: "ench\xE8res obligatoires",
        COMPULSORY_AUCTION_prefixed: "pour ench\xE8res obligatoires",
        RENT: "louer",
        RENT_prefixed: "\xE0 louer"
      },
      estateType: {
        AGRICULTURE_FORESTRY: "Agriculture / Sylviculture",
        AGRICULTURE_FORESTRY_prefixed: "une Agriculture / Sylviculture",
        APARTMENT: "Appartement",
        APARTMENT_prefixed: "un Appartement",
        BUILDING: "Immeuble",
        BUILDING_prefixed: "un Immeuble",
        GASTRONOMY_HOTEL: "Gastronomie / H\xF4tel",
        GASTRONOMY_HOTEL_prefixed: "un Gastronomie / H\xF4tel",
        HOUSE: "Maison",
        HOUSE_prefixed: "une Maison",
        MISCELLANEOUS: "Divers",
        MISCELLANEOUS_prefixed: "Divers",
        OFFICE: "Bureau",
        OFFICE_prefixed: "un Bureau",
        PARKING: "Parking",
        PARKING_prefixed: "un Parking",
        PLOT: "Terrain",
        PLOT_prefixed: "un Terrain",
        PROJECT: "Projet",
        PROJECT_prefixed: "un Projet",
        SENIOR: "R\xE9sidence pour personnes \xE2g\xE9es",
        SENIOR_prefixed: "une R\xE9sidence pour personnes \xE2g\xE9es",
        STORAGE_PRODUCTION: "Stockage / Production",
        STORAGE_PRODUCTION_prefixed: "un Stockage / Production",
        TRADING: "Boutique",
        TRADING_prefixed: "une Boutique"
      },
      travelMode: {
        BIKE: "v\xE9lo",
        BIKE_prefixed: "\xE0 v\xE9lo",
        CAR: "voiture",
        CAR_prefixed: "en voiture",
        TRANSIT: "transport en commun",
        TRANSIT_prefixed: "en transport en commun",
        WALK: "\xE0 pied",
        WALK_prefixed: "\xE0 pied"
      }
    },
    errorCreate: {
      text: "Impossible de sauvegarder cette recherche. R\xE9essayez plus tard."
    },
    errorDelete: {
      text: "Nous ne pouvons pas supprimer cette recherche."
    },
    errorPage: {
      action: "Acc\xE9der \xE0 ma recherche",
      text: "Il se peut que le lien que vous avez suivi soit rompu ou que la page ait \xE9t\xE9 supprim\xE9e.",
      title: "Cette page n'est pas disponible."
    },
    errorPageGeneric: {
      text: "La page n'est pas disponible. Veuillez r\xE9essayer ult\xE9rieurement.",
      title: "Une erreur s'est produite"
    },
    errorTechnicalRetry: {
      text: "Une erreur technique ait survenue. R\xE9essayez plus tard."
    },
    errorUpdate: {
      text: "Impossible de mettre \xE0 jour votre recherche. R\xE9essayez plus tard."
    },
    estate_type: {
      agriculture_forestry: "Agriculture / sylviculture",
      apartment: "Appartement",
      gastronomy_hotel: "Gastronomie / H\xF4tel",
      house: "Maison",
      house_apartment: "Maison / Appartement",
      investment_property: "Investissement immobilier",
      miscellaneous: "Divers",
      office: "Bureau",
      parking: "Parking",
      plot: "Terrain",
      project: "Projet",
      shared_apartment: "Appartement partag\xE9",
      storage_production: "Stockage / Production",
      temporary_living: "Logement temporaire",
      trading: "Boutique"
    },
    frequencyEdit: {
      email: "E-mail",
      frequency: {
        daily: "Une fois par jour",
        hourly: "Une fois par heure",
        never: "Jamais",
        realtime: "En temps r\xE9el",
        title: "Fr\xE9quence des notifications"
      },
      recommendation: {
        text: "Obtenez des offres alternatives \xE0 vos crit\xE8res de recherche pr\xE9d\xE9finis",
        title: "Recevoir des recommandations"
      },
      title: "Param\xE8tres de recherche",
      trigger: "Fr\xE9quence des notifications"
    },
    geometry_location: {
      title: "zone personnalis\xE9e"
    },
    getAlerts: {
      action: "Sauvegarder la recherche"
    },
    goBack: {
      action: "Retour"
    },
    goToSearch: {
      action: "Commencer"
    },
    hint: {
      animatedHint: {
        text: "Recevez les nouveaux biens qui vous correspondent en temps r\xE9el.",
        title: "Acc\xE9l\xE9rez votre recherche"
      },
      default: {
        text: "Recevez imm\xE9diatement les nouveaux biens correspondant \xE0 vos crit\xE8res.",
        title: "Suivez cette recherche"
      },
      travel_time: {
        text: "Gagnez du temps en sauvegardant votre recherche et recevez les derni\xE8res annonces d\xE8s qu\u2019elles sont publi\xE9es !",
        title: "Nouvelle fonctionnalit\xE9"
      }
    },
    hpMfe: {
      mvp: {
        blockText: "On continue ?"
      },
      noMore: {
        firstAction: "Voir plus de biens",
        firstText: "C'est tout pour le moment !",
        secondAction: "Nouvelle recherche",
        secondText: "Vous pouvez d\xE9sormais..."
      },
      seeMore: {
        action: "Voir plus de biens",
        text: "{{number}} autres propri\xE9t\xE9s dans la s\xE9lection"
      },
      text: "Nouveau(x) bien(s) li\xE9(s) \xE0 votre recherche sauvegard\xE9e",
      title: "Du nouveau pour votre recherche sauvegard\xE9e"
    },
    iconCriteria: {
      rooms: {
        text: "pc"
      }
    },
    intermediaryMatchingMandate: {
      errors: {
        consent: "Sans votre accord, nous ne pouvons transmettre vos coordonn\xE9es \xE0 une s\xE9lection d'agences immobili\xE8res pour vous accompagner dans votre projet immobilier.",
        email: "L'email n'est pas valide",
        phoneNumber: "Le format du num\xE9ro de t\xE9l\xE9phone n'est pas valide",
        required: "Le champ {{field}} est obligatoire",
        string: "Format incorrect"
      },
      informations: "En envoyant votre demande, vous acceptez le service Immowelt. Vous recevrez des informations bas\xE9es sur les donn\xE9es que vous avez saisies, les services utilis\xE9s et l'objectif de notre activit\xE9. Vous pouvez vous opposer \xE0 ce service \xE0 tout moment \xE0 l'adresse datenschutz@immowelt.de. Vous trouverez de plus amples informations dans la d\xE9claration de protection des donn\xE9es.",
      labels: {
        consent: "J'accepte que mes donn\xE9es soient transmises \xE0 une s\xE9lection d'agences immobili\xE8res proposant des biens correspondant \xE0 ma recherche, qui pourront me contacter par email ou par t\xE9l\xE9phone pour m'aider dans mon projet immobilier.",
        email: "Email",
        message: "Votre message",
        name: "Nom",
        phoneNumber: "T\xE9l\xE9phone"
      },
      legal: {
        text: {
          first: "Digital Classifieds {{country}} proc\xE8de au traitement de vos donn\xE9es afin de les transmettre \xE0 l\u2019annonceur indiqu\xE9. Dans ce cadre, nous transmettrons ces donn\xE9es \xE0 nos entit\xE9s",
          fourth: "s'appliquent.",
          link: {
            first: "AVIV Group",
            second: "Politique de Confidentialit\xE9.",
            third: "Conditions G\xE9n\xE9rales d\u2019Utilisation"
          },
          second: "et nos prestataires de services externes. Vous pouvez retirer \xE0 tout moment votre consentement au traitement des donn\xE9es facultatives. Pour plus d'informations sur vos droits et vos donn\xE9es, consultez notre",
          third: 'En cliquant sur "Confirmer ma demande", nos'
        }
      },
      placeholders: {
        message: "Fournissez des d\xE9tails pour aider nos experts \xE0 comprendre exactement ce que vous recherchez.",
        phoneNumber: "+33 XXX XXX XXX"
      },
      submit: "Confirmer ma demande",
      success: "Votre demande de contact a \xE9t\xE9 envoy\xE9e avec succ\xE8s.",
      suggestions: {
        text: "Recevez des propositions directes d'agents de confiance, y compris des annonces in\xE9dites adapt\xE9es \xE0 vos pr\xE9f\xE9rences.",
        title: "Obtenez des suggestions de propri\xE9t\xE9s aupr\xE8s d'agents"
      }
    },
    loader_text: "La page est en cours de chargement",
    match: {
      type: {
        boost: "Boost",
        new: "Nouveau match"
      }
    },
    noAlertError: {
      text: "Allez \xE0 la page de recherche et saisissez vos crit\xE8res.",
      title: "Sauvegardez votre premi\xE8re recherche"
    },
    notificationHub: {
      notLoggedIn: {
        button: "Se connecter",
        text: "Retrouver ici vos annonces et recherches sauvegard\xE9es.",
        title: "Connectez-vous pour voir vos notifications"
      },
      withoutContent: {
        button: "Aller \xE0 la recherche",
        text: "Explorez les propri\xE9t\xE9s et recevez des notifications lorsque de nouvelles annonces correspondent \xE0 votre recherche.",
        title: "Commencer \xE0 recevoir des notifications"
      }
    },
    notifications: {
      area: {
        draw: "Zone personnalis\xE9e",
        travelTime: "Trajet {{count}} {{unit}} {{mode}}, {{city}}"
      },
      aria: {
        close: "Fermer le centre de notifications",
        ssmui: "G\xE9rez vos notifications"
      },
      recommendations: "Recommandations",
      title: "Notifications",
      tooltip: "Mettez \xE0 jour vos param\xE8tres de notifications et recevez des annonces bas\xE9es sur vos crit\xE8res de recherche."
    },
    pauseAllNotifications: {
      action: "Suspendre toutes les notifications"
    },
    preUser: {
      create: {
        text: "Entrez votre email pour recevoir les nouvelles annonces.",
        title: "Presque termin\xE9..."
      },
      created: {
        register: "Cr\xE9er un compte",
        skip: "Ignorer",
        text: "Il ne vous reste plus qu'une \xE9tape pour cr\xE9er un compte. Cela vous permettra de g\xE9rer plus facilement vos recherches enregistr\xE9es et vos favoris.",
        title: "Votre notification par email est activ\xE9e"
      },
      error: {
        generic: "Cr\xE9ez un compte ou connectez-vous pour sauvegarder cette recherche."
      },
      legal: {
        linkWording: {
          first: "Groupe AVIV",
          second: "en cliquant ici",
          third: "Politique de confidentialit\xE9"
        },
        text: {
          first: "Ces donn\xE9es pourront \xEAtre transmises aux soci\xE9t\xE9s du",
          second: "\xE0 laquelle nous appartenons. Pour exercer vos droits sur vos donn\xE9es (acc\xE8s, rectification, effacement, opposition, portabilit\xE9, limitation), contactez-nous \xE0 cette adresse : Digital Classifieds France - 2-8 rue des Italiens 75009 Paris ou par",
          third: "Pour plus d'informations, consultez notre"
        }
      }
    },
    resubscribe: {
      action: "Se r\xE9abonner"
    },
    secondPage: {
      text: "Recevez les nouveaux biens correspondant \xE0 vos crit\xE8res.",
      title: "Acc\xE9l\xE9rez votre recherche en activant vos notifications"
    },
    segmentationUnsub: {
      buttons: {
        continue: "Continuer la recherche",
        manage: "G\xE9rez vos recherches sauvegard\xE9es"
      },
      text: {
        confirm: "Toutes vos recherches sauvegard\xE9es ont \xE9t\xE9 d\xE9sactiv\xE9es.",
        landing: "Vous vous d\xE9sabonnerez \xE9galement de toutes les recherches enregistr\xE9es"
      },
      title: {
        confirm: "Vous vous \xEAtes d\xE9sabonn\xE9 avec succ\xE8s",
        landing: "Se d\xE9sinscrire"
      }
    },
    serpBanner: {
      text: "Recevez les nouveaux biens qui vous correspondent en temps r\xE9el.",
      title: "Acc\xE9l\xE9rez votre recherche"
    },
    timeFormat: {
      day: "{{count}}j",
      hour: "{{count}}h",
      minute: "{{count}}mn",
      month: "{{count}}m",
      week: "{{count}}s"
    },
    title: {
      circles: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) autour de {{placeName}} +{{radius}} {{radiusUnit}}",
      default: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed)",
      errors: {
        tooLarge: "Maximum 100 caract\xE8res autoris\xE9s"
      },
      location: "{{estateTypes, list(type: disjunction)}} {{distributionType}} {{location}}",
      places: '{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) $t(savedSearch.criterias.location.places, { "context": "prefixed", "placeName":  "{{placeName}}", "count": {{placeCount}} })',
      polygons: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) dans votre zone personnalis\xE9e",
      travels: "{{estateTypes, list(type: disjunction)}} $t(savedSearch.enums.distributionType.{{distributionType}}_prefixed) \xE0 {{duration}} min {{mode}} de {{placeName}}"
    },
    unsubscribedEmailAlertSuccessfully: {
      title: "Vous avez \xE9t\xE9 d\xE9sabonn\xE9 avec succ\xE8s de {{alertName}}."
    },
    youCanAlso: {
      title: "Vous pouvez \xE9galement :"
    }
  },
  savedSearch_alertClose_action: "Fermer",
  savedSearch_alertCreated_action_text: "Voir mes recherches",
  savedSearch_alertCreated_text: "Votre recherche a \xE9t\xE9 sauvegard\xE9e.",
  savedSearch_alertDelete_text: "Votre recherche a \xE9t\xE9 supprim\xE9e.",
  savedSearch_alertEdit_action2: "Modifier les notifications",
  savedSearch_alertNotCreated_text: "Impossible de sauvegarder cette recherche",
  savedSearch_alertUpdated_text: "Votre recherche a \xE9t\xE9 sauvegard\xE9e.",
  savedSearch_buttonCard_title: "Recevez des notifications en temps r\xE9el",
  savedSearch_deleteAlert_title: "Sauvegardez une recherche",
  savedSearch_duplicateError_text: "Vous avez d\xE9j\xE0 sauvegard\xE9 cette recherche",
  savedSearch_duplicatePlaceId_text: "Il y a un probl\xE8me avec la zone que vous avez s\xE9lectionn\xE9e, veuillez r\xE9essayer plus tard",
  savedSearch_errorSameSearchCriteria_text: "Vous avez d\xE9j\xE0 une recherche sauvegard\xE9e comportant les m\xEAmes crit\xE8res.",
  savedSearch_errorTechnical_text: "Une erreur technique s'est produite",
  savedSearch_invalidPolygonShape_text: "La zone dessin\xE9e n'est pas valide. Les lignes ne peuvent pas se croiser.",
  savedSearch_invalidPolygon_text: "Une erreur s'est produite avec votre zone de recherche, veuillez ajuster votre zone",
  savedSearch_locationTooLarge_text: "Zone de recherche trop grande, veuillez r\xE9duire le nombre de localisations.",
  savedSearch_locationTooSmall_text: "La zone de recherche s\xE9lectionn\xE9e est trop petite",
  savedSearch_niceJob_text: "Vous pouvez maintenant en sauvegarder une nouvelle.",
  savedSearch_niceJob_title: "Votre recherche a \xE9t\xE9 supprim\xE9e",
  savedSearch_placeIDforbidden_text: "Le type de lieu que vous avez s\xE9lectionn\xE9 n'est pas pris en charge, veuillez choisir une valeur diff\xE9rente",
  savedSearch_polygonAlert_text: "Il n\u2019est pas possible de sauvegarder une recherche pour cette zone.",
  "savedSearch_there\u2019sNoRoomLeft_text": "Pour sauvegarder une nouvelle recherche, supprimez-en au moins une.",
  "savedSearch_there\u2019sNoRoomLeft_title": "Supprimez une recherche"
};

// src/Utils/locales/nl/translation.json
var translation_default4 = {
  SavedSearch: {
    actions: {
      editAlertCTA: ""
    },
    notificationpopup: {
      title1: ""
    },
    searchresults: {
      bodycopy: "",
      cta: ""
    },
    warningfeedbackmessage: {
      bodycopy: "",
      title: ""
    }
  },
  SavedSearch_alertEdit_action1: "",
  SavedSearch_alertEdit_action3: "",
  savedSearch: {
    actions: {
      alertTitle: "",
      disabled: "",
      editAlert: "",
      enabled: "",
      listings: "",
      modalChange: "Wijzigingsmeldingen",
      modalDelete: "Verwijderen",
      modalEdit: "",
      resetChanges: "",
      update: ""
    },
    alert: {
      title: "Meldingen"
    },
    alertActivated: {
      action: "Melding ingeschakeld"
    },
    alertAlertsTab: {
      action: "Meldingen"
    },
    alertAppNotifications: {
      option: "App-berichten"
    },
    alertContinue: {
      action: ""
    },
    alertCreate: {
      action: "Een melding maken",
      text: "Ontvang meldingen wanneer een nieuwe eigendom voldoet aan je criteria"
    },
    alertDeletePopUp: {
      text: "Je hebt het maximale aantal meldingen bereikt. Verwijder er ten minste \xE9\xE9n van om door te gaan.",
      title: "Een melding verwijderen"
    },
    alertEdit: {
      title: "Mijn melding bewerken"
    },
    alertEmail: {
      actionCreate: "",
      created: {
        action: "",
        text: "",
        title: ""
      },
      disclaimer: {
        link: "",
        text: ""
      },
      invalid: "",
      option: "E-mail",
      text: ""
    },
    alertEmptyState: {
      text: "Krijg een bericht wanneer nieuwe advertenties voldoen aan je criteria.",
      title: "Geen melding"
    },
    alertFavouritesTab: {
      action: "Verlanglijst"
    },
    alertForceLogin: {
      promote: "",
      text: "Log in om je meldingen in te stellen. Je ontvangt een bericht wanneer nieuwe advertenties aan je criteria voldoen.",
      title: "Log in om je meldingen te beheren"
    },
    alertInternetError: {
      text: "Schakel je mobiele gegevens in of maak verbinding met een wifi-netwerk.",
      title: "Geen internetverbinding"
    },
    alertInvalid: {
      text: "Ongeldige zoekcriteria"
    },
    alertLoading: {
      title: "Meldingen worden geladen"
    },
    alertResubscribe: {
      action: "Verder zoeken",
      link: "Opnieuw abonneren",
      secondTitle: "Je kunt ook:",
      text: "Bedankt dat je bij ons bent gebleven.",
      title: "Je abonnement is opnieuw geactiveerd."
    },
    alertRetry: {
      action: "Opnieuw proberen"
    },
    alertSave: {
      action: "De melding maken"
    },
    alertSee: {
      action: "Eigendommen bekijken"
    },
    alertSetup: {
      title: "Ontvang een bericht van nieuwe advertenties"
    },
    alertSignin: {
      action: "Inloggen"
    },
    alertSignup: {
      action: "Registreren"
    },
    alertTechnicalError: {
      text: "Er is een technische fout opgetreden. Probeer het later opnieuw.",
      title: "Er ging iets mis"
    },
    alertUnsubscribe: {
      acknowledgement: "Bedankt voor je feedback",
      form: {
        submit: "Feedback verzenden"
      },
      radioGroup: {
        label: "Vertel ons hoe we het beter kunnen doen"
      },
      title: "Je bent succesvol uitgeschreven van {{alertName}}"
    },
    alertValidate: {
      action: "Valideren"
    },
    alertsPaused: {
      text: "Berichten voor alle meldingen zijn gepauzeerd. Je kunt ze op elk moment opnieuw activeren."
    },
    anonymousRegister: {
      action: "Registreren",
      text: "Alleen dan kunt u al uw opgeslagen zoekopdrachten zien.",
      title: "Log alsjeblieft in"
    },
    cancel: {
      action: "Annuleer"
    },
    card: {
      carousel: {
        title: ""
      }
    },
    checkbox: {
      marketing: "",
      partner: {
        firstText: "",
        secondText: ""
      }
    },
    createAlertsByHitting: {
      text: "Je kunt een melding maken vanaf de pagina met zoekresultaten."
    },
    criterias: {
      area: {
        title: "Gebied"
      },
      common: {
        range: {
          label: {
            max: "Max",
            min: "Min"
          }
        }
      },
      context_switch: {
        commercial: "Voor mijn bedrijf",
        residential: "Voor mij"
      },
      estate_subtype: {
        agriculture_forestry: {
          checkbox: {
            agriculture_company: "Landbouwbedrijf",
            farm_ranch: "Boerderij",
            forestry: "Bosbouw",
            gardening_orchard: "Tuinieren / Boomgaard",
            hunting_fishing: "Jagen/Vissen",
            riding: "rijden",
            winery: "Wijnmakerij"
          },
          title: "Type landgoed"
        },
        apartment: {
          checkbox: {
            loft: "Zolder",
            multi_storey: "Meer verdiepingen",
            penthouse: "Penthouse",
            studio: "Studio",
            terrace: "Terras"
          },
          title: "Landgoed type"
        },
        gastronomy_hotel: {
          checkbox: {
            cafe_bar_pub: "Caf\xE9 / Bar / Pub",
            club_discotheque: "Club / Discotheek",
            hotel_pension: "Hotel / Pension",
            restaurant: "Restaurant"
          },
          title: "Type landgoed"
        },
        house: {
          checkbox: {
            bungalow: "Bungalow",
            castle: "Kasteel",
            chalet: "Chalet",
            farmhouse: "Boerderij",
            finca: "Finca",
            manor_house: "Landhuis",
            multi_family_house: "Meergezinswoning",
            rustico: "Rustico",
            semidetached_house: "Halfvrijstaand huis",
            single_family_house: "Eengezinswoning",
            terrace_house: "Terraswoning",
            town_house: "Herenhuis",
            villa: "Villa"
          },
          title: "Type huis"
        },
        office: {
          checkbox: {
            atelier: "Atelier",
            coworking: "Coworking",
            living_and_commercial_building: "Wonen en commerci\xEBle gebouwen",
            medical: "Medisch",
            office: "Kantoor"
          },
          title: "Type kantoor"
        },
        parking: {
          checkbox: {
            carport: "Carport",
            duplex: "Duplex",
            garage: "Garage",
            outside: "Buiten parkeren",
            underground_garage: "Ondergrondse garage",
            underground_parking_space: "Ondergronds parkeren"
          },
          title: "Type parkeerplaats"
        },
        plot: {
          checkbox: {
            commercial: "Commercieel",
            leisure_facility: "Vrijetijdscentrum",
            living: "Wonen"
          },
          title: "Type perceel"
        },
        storage_production: {
          checkbox: {
            garage_repair: "Garage / Reparatie",
            logistic_center: "Logistiek centrum",
            miscellaneous_storage: "Diverse opslag",
            outdoor_space: "Buitenruimte",
            production_hall: "Productiehal",
            warehouse_hall: "Magazijn"
          },
          title: "Type landgoed"
        },
        trading: {
          checkbox: {
            kiosk: "Kiosk",
            sales_area: "Verkoopgebied",
            shopping_centre: "Winkelcentrum",
            showroom_space: "Showroom ruimte",
            store: "Winkel"
          },
          title: "Type winkel"
        }
      },
      features: {
        checkbox: {
          attic_apartment: "Zolder appartement",
          balcony_terrace: "Balkon / Terras",
          bathroom_with_bathtub: "Badkamer met bad",
          bathroom_with_window: "Badkamer met raam",
          built_in_kitchen: "Ingebouwde keuken",
          cellar: "Kelder",
          certificate_of_eligibility_needed: "",
          elevator: "Lift",
          free_of_commission: "Vrij van commissie",
          furnished: "Volledig gemeubileerd",
          garden: "Tuin",
          no_attic_apartment: "Geen zolderappartement",
          no_ground_floor: "Geen begane grond",
          parking_garage: "Parkeren / Garage",
          pets_allowed: "Huisdieren toegestaan",
          reduced_mobility_access: "Toegang met beperkte mobiliteit",
          unfurnished: "Ongemeubileerd",
          vacant: "Leeg / Niet verhuurd"
        },
        subtitle: {
          accessibility: "Toegankelijkheid",
          furnished_unfurnished: "Gemeubileerd / Gestoffeerd",
          indoor: "Binnen",
          usage: "Gebruik"
        },
        title: {
          features_excluded: "",
          features_included: "",
          foreclosure: "Verkoop",
          new_builds: "Nieuwbouw",
          subsidizing_housing: "Huisvesting subsidi\xEBren"
        }
      },
      floor: "Vloer",
      floors: {
        checkbox: {
          ground_floor: "Begane grond",
          no_ground_floor: "Geen begane grond",
          other_floors: "Andere vloeren"
        }
      },
      living_area: {
        input_field: {
          surface_type: "m\xB2"
        },
        title: "Leefruimte"
      },
      location: {
        circles: "",
        circles_prefixed: "",
        places_one: "",
        places_other: "",
        places_prefixed_one: "",
        places_prefixed_other: "",
        places_prefixed_zero: "",
        polygons: "",
        polygons_prefixed: "",
        travels: "",
        travels_prefixed: ""
      },
      plot_area: {
        input_field: {
          surface_type: "m\xB2"
        },
        title: ""
      },
      project_type: {
        checkbox: {
          foreclosure_sale: "Verkoop",
          investment: "Investering",
          new_builds: "Nieuwbouw",
          resale: "Wederverkoop",
          shared_flats: "Gedeelde flats",
          stock: "Voorraad",
          temporary_living: "Tijdelijk wonen"
        },
        title: "Type project"
      }
    },
    deleteAlertConfirmation: {
      feedback: {
        label: "Vertel ons hoe we het beter kunnen doen",
        submit: "Feedback verzenden",
        success: "feedback verzenden"
      },
      text: "",
      title: "Weet je zeker dat je deze melding wilt verwijderen?"
    },
    distribution_type: {
      buy: "Kopen",
      compulsory_auction: "Verplichte veiling",
      rent: "Huren"
    },
    emailResubscribed: {
      action: "Doorgaan met zoeken",
      text: "Bedankt om bij ons te blijven.",
      title: "Je hebt je opnieuw geabonneerd."
    },
    enums: {
      distributionType: {
        BUY: "",
        BUY_AUCTION: "",
        BUY_AUCTION_prefixed: "",
        BUY_prefixed: "",
        COMPULSORY_AUCTION: "",
        COMPULSORY_AUCTION_prefixed: "",
        RENT: "",
        RENT_prefixed: ""
      },
      estateType: {
        AGRICULTURE_FORESTRY: "",
        AGRICULTURE_FORESTRY_prefixed: "",
        APARTMENT: "",
        APARTMENT_prefixed: "",
        BUILDING: "",
        BUILDING_prefixed: "",
        GASTRONOMY_HOTEL: "",
        GASTRONOMY_HOTEL_prefixed: "",
        HOUSE: "",
        HOUSE_prefixed: "",
        MISCELLANEOUS: "",
        MISCELLANEOUS_prefixed: "",
        OFFICE: "",
        OFFICE_prefixed: "",
        PARKING: "",
        PARKING_prefixed: "",
        PLOT: "",
        PLOT_prefixed: "",
        PROJECT: "",
        PROJECT_prefixed: "",
        SENIOR: "",
        SENIOR_prefixed: "",
        STORAGE_PRODUCTION: "",
        STORAGE_PRODUCTION_prefixed: "",
        TRADING: "",
        TRADING_prefixed: ""
      },
      travelMode: {
        BIKE: "",
        BIKE_prefixed: "",
        CAR: "",
        CAR_prefixed: "",
        TRANSIT: "",
        TRANSIT_prefixed: "",
        WALK: "",
        WALK_prefixed: ""
      }
    },
    errorCreate: {
      text: "We konden de melding niet maken. Probeer het later opnieuw."
    },
    errorDelete: {
      text: "Kan je melding niet verwijderen."
    },
    errorPage: {
      action: "Ga naar zoekmeldingen",
      text: "De link die je volgde kan verbroken zijn of de pagina kan verwijderd zijn.",
      title: "Deze pagina is niet beschikbaar."
    },
    errorPageGeneric: {
      text: "",
      title: ""
    },
    errorTechnicalRetry: {
      text: "Er is een technische fout opgetreden. Probeer het later opnieuw."
    },
    errorUpdate: {
      text: "Kan je melding niet bijwerken. Probeer het later opnieuw."
    },
    estate_type: {
      agriculture_forestry: "Landbouw / Bosbouw",
      apartment: "Appartement",
      gastronomy_hotel: "Gastronomie / Hotel",
      house: "Huis",
      house_apartment: "Huis / Appartement",
      investment_property: "Vastgoedbelegging",
      miscellaneous: "Diverse",
      office: "Kantoor",
      parking: "Parkeren",
      plot: "Perceel",
      project: "Project",
      shared_apartment: "Gedeeld appartement",
      storage_production: "Opslag / Productie",
      temporary_living: "Tijdelijk wonen",
      trading: "Winkel op"
    },
    frequencyEdit: {
      email: "",
      frequency: {
        daily: "",
        hourly: "",
        never: "",
        realtime: "",
        title: ""
      },
      recommendation: {
        text: "",
        title: ""
      },
      title: "",
      trigger: ""
    },
    geometry_location: {
      title: ""
    },
    getAlerts: {
      action: "Een melding maken"
    },
    goBack: {
      action: ""
    },
    goToSearch: {
      action: "Ga naar zoekopdracht"
    },
    hint: {
      animatedHint: {
        text: "",
        title: ""
      },
      default: {
        text: "",
        title: ""
      },
      travel_time: {
        text: "Het is nu mogelijk om uw zoekopdracht op te slaan!",
        title: "Nieuwe functie"
      }
    },
    hpMfe: {
      mvp: {
        blockText: ""
      },
      noMore: {
        firstAction: "",
        firstText: "",
        secondAction: "",
        secondText: ""
      },
      seeMore: {
        action: "",
        text: ""
      },
      text: "",
      title: ""
    },
    iconCriteria: {
      rooms: {
        text: ""
      }
    },
    intermediaryMatchingMandate: {
      errors: {
        consent: "",
        email: "",
        phoneNumber: "",
        required: "",
        string: ""
      },
      informations: "",
      labels: {
        consent: "",
        email: "",
        message: "",
        name: "",
        phoneNumber: ""
      },
      legal: {
        text: {
          first: "",
          fourth: "",
          link: {
            first: "",
            second: "",
            third: ""
          },
          second: "",
          third: ""
        }
      },
      placeholders: {
        message: "",
        phoneNumber: ""
      },
      submit: "",
      success: "",
      suggestions: {
        text: "",
        title: ""
      }
    },
    loader_text: "",
    match: {
      type: {
        boost: "",
        new: ""
      }
    },
    noAlertError: {
      text: "",
      title: ""
    },
    notificationHub: {
      notLoggedIn: {
        button: "Inloggen",
        text: "Houd je opgeslagen aanbiedingen en zoekopdrachten bij.",
        title: "Meld je aan om je meldingen te zien"
      },
      withoutContent: {
        button: "Ga naar zoeken",
        text: "Ontdek woningen en ontvang meldingen wanneer er nieuwe aanbiedingen zijn die aan je zoekopdracht voldoen.",
        title: "Meldingen ontvangen starten"
      }
    },
    notifications: {
      area: {
        draw: "",
        travelTime: ""
      },
      aria: {
        close: "",
        ssmui: ""
      },
      recommendations: "",
      title: "",
      tooltip: ""
    },
    pauseAllNotifications: {
      action: "Pauzeer alle berichten"
    },
    preUser: {
      create: {
        text: "",
        title: ""
      },
      created: {
        register: "",
        skip: "",
        text: "",
        title: ""
      },
      error: {
        generic: ""
      },
      legal: {
        linkWording: {
          first: "",
          second: "",
          third: ""
        },
        text: {
          first: "",
          second: "",
          third: ""
        }
      }
    },
    resubscribe: {
      action: "Opnieuw abonneren"
    },
    secondPage: {
      text: "Activeer de waarschuwing om de nieuwe eigendommen te ontvangen die voldoen aan uw criteria",
      title: "Versnel uw zoekopdracht door een opgeslagen zoekopdracht aan te maken"
    },
    segmentationUnsub: {
      buttons: {
        continue: "",
        manage: ""
      },
      text: {
        confirm: "",
        landing: ""
      },
      title: {
        confirm: "U bent succesvol afgemeld",
        landing: "Uitschrijven"
      }
    },
    serpBanner: {
      text: "",
      title: ""
    },
    timeFormat: {
      day: "",
      hour: "",
      minute: "",
      month: "",
      week: ""
    },
    title: {
      circles: "",
      default: "",
      errors: {
        tooLarge: "Maximaal 100 tekens toegestaan"
      },
      location: "",
      places: "",
      polygons: "",
      travels: ""
    },
    unsubscribedEmailAlertSuccessfully: {
      title: "Je bent met succes afgemeld voor {{alertName}}."
    },
    youCanAlso: {
      title: "Je kunt ook:"
    }
  },
  savedSearch_alertClose_action: "Afsluiten",
  savedSearch_alertCreated_action_text: "",
  savedSearch_alertCreated_text: "Je melding werd gemaakt.",
  savedSearch_alertDelete_text: "Je melding werd verwijderd.",
  savedSearch_alertEdit_action2: "",
  savedSearch_alertNotCreated_text: "Kan de melding niet maken.",
  savedSearch_alertUpdated_text: "Je melding werd gemaakt.",
  savedSearch_buttonCard_title: "",
  savedSearch_deleteAlert_title: "Bewaar zoekactie",
  savedSearch_duplicateError_text: "",
  savedSearch_duplicatePlaceId_text: "",
  savedSearch_errorSameSearchCriteria_text: "Je hebt al een melding met dezelfde zoekcriteria.",
  savedSearch_errorTechnical_text: "Er is een technische fout opgetreden.",
  savedSearch_invalidPolygonShape_text: "",
  savedSearch_invalidPolygon_text: "",
  savedSearch_locationTooLarge_text: "",
  savedSearch_locationTooSmall_text: "",
  savedSearch_niceJob_text: "Nu kun je de nieuwe melding maken.",
  savedSearch_niceJob_title: "Je melding werd verwijderd",
  savedSearch_placeIDforbidden_text: "",
  savedSearch_polygonAlert_text: "",
  "savedSearch_there\u2019sNoRoomLeft_text": "",
  "savedSearch_there\u2019sNoRoomLeft_title": "Een melding verwijderen"
};

// src/Utils/hooks/useTranslation.ts
var resources = {
  de: translation_default,
  en: translation_default2,
  fr: translation_default3,
  nl: translation_default4
};
var I18N_NAMESPACE = "app_ssal_shared";
var useLoadTranslations = () => {
  const { language } = useLocale();
  const { addTranslations } = useTranslation$1(I18N_NAMESPACE);
  const removeTranslations = useRef(() => {
  });
  removeTranslations.current = useMemo(() => {
    removeTranslations.current();
    return addTranslations({
      language,
      translations: resources[language]
    });
  }, [addTranslations, language]);
};
var useTranslation = () => {
  const { t } = useTranslation$1(I18N_NAMESPACE);
  return { t };
};

// src/Utils/check/index.ts
var isWindowUndefined = () => typeof window === "undefined";
var isDocumentUndefined = () => typeof document === "undefined";
var isLocalStorageUndefined = () => typeof localStorage === "undefined";
var isSSR = () => isWindowUndefined() || isDocumentUndefined() || isLocalStorageUndefined();

// src/Utils/config/brands/imn-deu.ts
var config_IMN_DEU = {
  brandId: "imn",
  searchBrand: "immonet",
  favoriteBrand: "immonet",
  brandLabel: "Immonet",
  links: {
    mySpace: "/meinbereich",
    ssmui: "nutzerportal/gespeicherte-suchen",
    partners: "https://www.immonet.de/datenschutz?_gl=1crsyry_gcl_au*NjA1MTk4ODE4LjE3NDkwNDUxNTE.#c20764"
  },
  hostnames: {
    signIn: "https://{env}signin.immonet.de"
  },
  tracking: {
    site: "INT"
  },
  legals: {
    upperLocal: "DE",
    country: "Deutschland",
    terms: "https://www.immonet.de/service/agb.html",
    policy: "https://www.immonet.de/datenschutz",
    contact: "https://www.immonet.de/service/kontakt.html"
  },
  legacy: {
    loadingEnabled: false,
    checkMigrationState: false,
    useRecommendations: false,
    channelInteractionEnabled: true
  },
  recommendations: true,
  createUtils: {
    supported: true,
    emailRequired: false
  },
  button: {
    supported: true,
    supportCard: true,
    legacy: true,
    preUser: true,
    hintFeatures: {
      default: true,
      travelTime: false,
      hpHint: true
    },
    intermediaryMatchingMandate: false,
    intermediaryMatchingMandateWithLocal: false,
    secondPageAlertModal: true
  },
  login: {
    supported: true,
    oauth: true
  },
  anonymous: {
    supported: true,
    promoteLogin: true
  },
  hpList: {
    supported: true,
    showMore: false,
    withRelaxed: false
  },
  favorites: {
    homepage: false,
    cardCarousel: true
  },
  notificationHub: {
    supported: true,
    illustrationsType: {
      withoutContent: "german"
    }
  }
};

// src/Utils/config/brands/iwt-deu.ts
var config_IWT_DEU = {
  brandId: "iwt",
  searchBrand: "immowelt",
  favoriteBrand: "immowelt",
  brandLabel: "Immowelt",
  links: {
    mySpace: "/meinbereich",
    ssmui: "nutzerportal/gespeicherte-suchen",
    partners: "https://www.immowelt.de/immoweltag/datenschutz?_gl=115uyapg_gcl_au*MTIyNjAyMjk3MC4xNzQ5MDQyNTQ1#c20764"
  },
  hostnames: {
    signIn: "https://{env}signin.immowelt.de"
  },
  tracking: {
    site: "IWT"
  },
  legals: {
    upperLocal: "DE",
    country: "Deutschland",
    terms: "https://www.immowelt.de/immoweltag/agb",
    policy: "https://www.immowelt.de/immoweltag/datenschutz",
    contact: "https://www.immowelt.de/immoweltag/kundenservice/hotline"
  },
  legacy: {
    loadingEnabled: false,
    checkMigrationState: false,
    useRecommendations: true,
    channelInteractionEnabled: true
  },
  recommendations: true,
  createUtils: {
    supported: true,
    emailRequired: false
  },
  button: {
    supported: true,
    supportCard: false,
    legacy: true,
    preUser: true,
    hintFeatures: {
      default: true,
      travelTime: false,
      hpHint: true
    },
    intermediaryMatchingMandate: false,
    intermediaryMatchingMandateWithLocal: false,
    secondPageAlertModal: true
  },
  login: {
    supported: true,
    oauth: true
  },
  anonymous: {
    supported: true,
    promoteLogin: true
  },
  hpList: {
    supported: true,
    showMore: false,
    withRelaxed: false
  },
  favorites: {
    homepage: false,
    cardCarousel: true
  },
  notificationHub: {
    supported: true,
    illustrationsType: {
      withoutContent: "german"
    }
  }
};

// src/Utils/config/brands/lim-fra.ts
var config_LIM_FRA = {
  brandId: "li",
  searchBrand: "logicimmo",
  favoriteBrand: "logicimmo",
  brandLabel: "Logic-Immo",
  links: {
    mySpace: "/mon-espace",
    ssmui: "mes-alertes",
    partners: "https://www.logic-immo.com/conditions-generales-d-utilisation.html"
  },
  hostnames: {
    signIn: "https://{env}signin.logic-immo.com"
  },
  tracking: {
    site: "LICOM"
  },
  legals: {
    upperLocal: "FR",
    country: "France",
    terms: "https://www.logic-immo.com/conditions-generales-d-utilisation.html",
    policy: "https://www.logic-immo.com/cgu-et-politique-de-confidentialite.html",
    contact: "https://www.logic-immo.com/contactez-nous#formSection"
  },
  legacy: {
    loadingEnabled: false,
    checkMigrationState: false,
    useRecommendations: false,
    channelInteractionEnabled: true
  },
  recommendations: true,
  createUtils: {
    supported: true,
    emailRequired: true
  },
  button: {
    supported: true,
    supportCard: true,
    legacy: true,
    preUser: true,
    hintFeatures: {
      default: true,
      travelTime: true,
      hpHint: true
    },
    intermediaryMatchingMandate: false,
    intermediaryMatchingMandateWithLocal: true,
    secondPageAlertModal: true
  },
  login: {
    supported: true,
    oauth: true
  },
  anonymous: {
    supported: true,
    promoteLogin: true
  },
  hpList: {
    supported: true,
    showMore: false,
    withRelaxed: false
  },
  favorites: {
    homepage: false,
    cardCarousel: true
  },
  notificationHub: {
    supported: true,
    illustrationsType: {
      withoutContent: "french"
    }
  }
};

// src/Utils/config/brands/slg-fra.ts
var config_SLG_FRA = {
  brandId: "sl",
  searchBrand: "seloger",
  favoriteBrand: "seloger",
  brandLabel: "SeLoger",
  links: {
    mySpace: "/mon-espace",
    ssmui: "mes-alertes",
    partners: "https://www.seloger.com/CGU_politique_de_confidentialite.html"
  },
  hostnames: {
    signIn: "https://{env}signin.seloger.com"
  },
  tracking: {
    site: "SL"
  },
  legals: {
    upperLocal: "FR",
    country: "France",
    terms: "https://www.seloger.com/Conditions_Generales_d_Utilisation.html",
    policy: "https://www.seloger.com/CGU_politique_de_confidentialite.html",
    contact: "https://www.seloger.com/contact.html"
  },
  legacy: {
    loadingEnabled: false,
    checkMigrationState: false,
    useRecommendations: false,
    channelInteractionEnabled: false
  },
  recommendations: true,
  createUtils: {
    supported: true,
    emailRequired: false
  },
  button: {
    supported: true,
    supportCard: true,
    legacy: false,
    preUser: true,
    hintFeatures: {
      default: true,
      travelTime: true,
      hpHint: true
    },
    intermediaryMatchingMandate: true,
    intermediaryMatchingMandateWithLocal: false,
    secondPageAlertModal: true
  },
  login: {
    supported: true,
    oauth: true
  },
  anonymous: {
    supported: true,
    promoteLogin: true
  },
  hpList: {
    supported: true,
    showMore: false,
    withRelaxed: false
  },
  favorites: {
    homepage: true,
    cardCarousel: true
  },
  notificationHub: {
    supported: true,
    illustrationsType: {
      withoutContent: "french"
    }
  }
};

// src/Utils/config/brands/sln-fra.ts
var config_SLN_FRA = {
  brandId: "sln",
  searchBrand: "selogerneuf",
  brandLabel: "SeLoger Neuf",
  hostnames: {
    // auth not supported yet on SLN
    signIn: "https://{env}signin.selogerneuf.com"
  },
  tracking: {
    site: "SLN"
  },
  legals: {
    upperLocal: "FR",
    country: "France",
    terms: "https://www.selogerneuf.com/conditions-generales-utilisation/",
    policy: "https://www.seloger.com/CGU_politique_de_confidentialite.html",
    contact: "https://www.seloger.com/contact.html"
  },
  legacy: {
    loadingEnabled: false,
    checkMigrationState: false,
    useRecommendations: false,
    channelInteractionEnabled: false
  },
  recommendations: false,
  createUtils: {
    supported: false,
    emailRequired: false
  },
  button: {
    supported: false,
    supportCard: false,
    legacy: false,
    preUser: false,
    hintFeatures: {
      default: false,
      travelTime: false,
      hpHint: false
    },
    intermediaryMatchingMandate: false,
    intermediaryMatchingMandateWithLocal: false,
    secondPageAlertModal: false
  },
  login: {
    supported: false,
    oauth: false
  },
  anonymous: {
    supported: false,
    promoteLogin: false
  },
  hpList: {
    supported: false,
    showMore: false,
    withRelaxed: false
  },
  favorites: {
    cardCarousel: false,
    homepage: false
  },
  notificationHub: {
    supported: false,
    illustrationsType: {
      withoutContent: "french"
    }
  }
};

// src/Utils/config/index.ts
var brandConfigs = {
  imn: config_IMN_DEU,
  iwt: config_IWT_DEU,
  sl: config_SLG_FRA,
  sln: config_SLN_FRA,
  li: config_LIM_FRA
};
function getBrandConfig(brand) {
  return brandConfigs[brand];
}
function getCustomBrandConfig(brand) {
  return brandConfigs[brand];
}

// src/Utils/api/Legacy/types.ts
var LegacyIWTRelaxMode = /* @__PURE__ */ ((LegacyIWTRelaxMode2) => {
  LegacyIWTRelaxMode2["None"] = "IGNORE_NONE";
  LegacyIWTRelaxMode2["SINGLE"] = "IGNORE_SINGLE";
  return LegacyIWTRelaxMode2;
})(LegacyIWTRelaxMode || {});
var LegacyIWTFeatures = /* @__PURE__ */ ((LegacyIWTFeatures2) => {
  LegacyIWTFeatures2["ROLLSTUHLGERECHT"] = "ROLLSTUHLGERECHT";
  LegacyIWTFeatures2["BARRIEREFREI"] = "BARRIEREFREI";
  LegacyIWTFeatures2["EINBAUKUECHE"] = "EINBAUKUECHE";
  LegacyIWTFeatures2["GARTEN"] = "GARTEN";
  LegacyIWTFeatures2["GARAGE_STELLPLATZ"] = "GARAGE_STELLPLATZ";
  LegacyIWTFeatures2["BALKON_TERRASSE"] = "BALKON_TERRASSE";
  LegacyIWTFeatures2["TEILWEISE_MOEBLIERT"] = "TEILWEISE_MOEBLIERT";
  LegacyIWTFeatures2["VOLL_MOEBLIERT"] = "VOLL_MOEBLIERT";
  LegacyIWTFeatures2["BAD_MIT_FENSTER"] = "BAD_MIT_FENSTER";
  LegacyIWTFeatures2["BAD_MIT_WANNE"] = "BAD_MIT_WANNE";
  LegacyIWTFeatures2["PERSONENAUFZUG"] = "PERSONENAUFZUG";
  LegacyIWTFeatures2["TEILWEISE_UNTERKELLERT"] = "TEILWEISE_UNTERKELLERT";
  LegacyIWTFeatures2["VOLL_UNTERKELLERT"] = "VOLL_UNTERKELLERT";
  LegacyIWTFeatures2["NICHT_UNTERKELLERT"] = "NICHT_UNTERKELLERT";
  LegacyIWTFeatures2["KEIN_DACHGESCHOSS"] = "KEIN_DACHGESCHOSS";
  LegacyIWTFeatures2["KEIN_ERDGESCHOSS"] = "KEIN_ERDGESCHOSS";
  LegacyIWTFeatures2["NEUBAU"] = "NEUBAU";
  LegacyIWTFeatures2["NEUWERTIG"] = "NEUWERTIG";
  LegacyIWTFeatures2["RENOVIERT"] = "RENOVIERT";
  LegacyIWTFeatures2["RENOVIERT_SANIERT"] = "RENOVIERT_SANIERT";
  LegacyIWTFeatures2["SANIERT"] = "SANIERT";
  LegacyIWTFeatures2["TEILSANIERT"] = "TEILSANIERT";
  LegacyIWTFeatures2["ERSTBEZUG"] = "ERSTBEZUG";
  LegacyIWTFeatures2["RENOVIERUNGSBEDUERFTIG"] = "RENOVIERUNGSBEDUERFTIG";
  LegacyIWTFeatures2["SANIERUNGSBEDUERFTIG"] = "SANIERUNGSBEDUERFTIG";
  LegacyIWTFeatures2["GEPFLEGT"] = "GEPFLEGT";
  LegacyIWTFeatures2["NUR_NEUBAUPROJEKTE"] = "NUR_NEUBAUPROJEKTE";
  LegacyIWTFeatures2["KELLER"] = "KELLER";
  LegacyIWTFeatures2["FREI"] = "FREI";
  LegacyIWTFeatures2["HAUSTIERE_ERLAUBT"] = "HAUSTIERE_ERLAUBT";
  LegacyIWTFeatures2["WOHNBERECHTIGUNGSSCHEIN"] = "WOHNBERECHTIGUNGSSCHEIN";
  return LegacyIWTFeatures2;
})(LegacyIWTFeatures || {});

// src/Components/SavedSearchButton/types.ts
var SavedSearchButtonOrigin = /* @__PURE__ */ ((SavedSearchButtonOrigin2) => {
  SavedSearchButtonOrigin2["SEO_COMPONENT"] = "serp_seo_component";
  SavedSearchButtonOrigin2["MAP"] = "serp_map";
  SavedSearchButtonOrigin2["FULL_LIST"] = "serp_full_list";
  SavedSearchButtonOrigin2["LAST_LISTING"] = "lastlisting";
  SavedSearchButtonOrigin2["WL_HP_LAST_SEARCH"] = "wl_hp_last_search";
  SavedSearchButtonOrigin2["SECOND_PAGE_LIST"] = "second_page_list";
  SavedSearchButtonOrigin2["SERP_NO_RESULTS"] = "serp_no_results";
  return SavedSearchButtonOrigin2;
})(SavedSearchButtonOrigin || {});
var REST_RETRY_COUNT = 2;
var REST_RETRY_TIMEOUT = 3e3;
var legacyAlternativesOn = {
  location: 10,
  primaryPriceMax: 10,
  primaryAreaMin: 10,
  relaxEquipmentMode: "IGNORE_SINGLE" /* SINGLE */
};
var legacyAlternativesOff = {
  location: 0,
  primaryPriceMax: 0,
  primaryAreaMin: 0,
  relaxEquipmentMode: "IGNORE_NONE" /* None */
};
var errorCodes = {
  tooMany: "ERROR_TOO_MANY_SAVED_SEARCHES",
  duplicated: "ERROR_DUPLICATED_SAVED_SEARCH",
  placeIdsTooHigh: "ERROR_NUMBER_OF_PLACEIDS_TOO_HIGH",
  tooLarge: "ERROR_LOCATION_AREA_TOO_LARGE",
  tooSmall: "ERROR_LOCATION_AREA_TOO_SMALL",
  duplicatePlaceId: "ERROR_DUPLICATE_PLACEID",
  placeType: "ERROR_LOCATION_PLACE_TYPE_NOT_ALLOWED",
  invalidPolygon: "ERROR_INVALID_POLYGON_DATA",
  invalidPolygonShape: "ERROR_INVALID_POLYGON_SHAPE",
  titleTooLong: "ERROR_TITLE_TOO_LONG"
};
var savedSearchApiErrorCode = [
  {
    errorCode: errorCodes.tooMany,
    translationKey: null
  },
  {
    errorCode: errorCodes.duplicated,
    translationKey: "savedSearch_duplicateError_text"
  },
  {
    errorCode: errorCodes.placeIdsTooHigh,
    translationKey: "savedSearch_locationTooLarge_text"
  },
  {
    errorCode: errorCodes.tooLarge,
    translationKey: "savedSearch_locationTooLarge_text"
  },
  {
    errorCode: errorCodes.tooSmall,
    translationKey: "savedSearch_locationTooSmall_text"
  },
  {
    errorCode: errorCodes.duplicatePlaceId,
    translationKey: "savedSearch_duplicatePlaceId_text"
  },
  {
    errorCode: errorCodes.placeType,
    translationKey: "savedSearch_placeIDforbidden_text"
  },
  {
    errorCode: errorCodes.invalidPolygon,
    translationKey: "savedSearch_invalidPolygon_text"
  },
  {
    errorCode: errorCodes.invalidPolygonShape,
    translationKey: "savedSearch_invalidPolygonShape_text"
  },
  {
    errorCode: errorCodes.titleTooLong,
    translationKey: "savedSearch.title.errors.tooLarge"
  }
];
var defaultChannels = [
  {
    channel: SavedSearchNotificationChannel.email,
    enabled: true
  }
];
var savedSearchButtonModalTestId = "av-ssab-Modal";
var intermediaryMatchingMandateTestId = "av-ssab-IntermediaryMatchingMandate";
var intermediaryMatchingMandateLokalizePrefix = "savedSearch.intermediaryMatchingMandate";
var intermediaryMatchingMandateLocalStorageKey = "showMatchingMandate";
var localKeys = {
  autoLocalStorageSearchKey: "auto_save_search",
  logSearchDataModel: "log_search_data_model",
  maxAlertsCustomKey: "max_alerts_count",
  autoSaveSearchQueryParam: "autoSaveSearch",
  secondPageAlreadyShown: "ssal_second_page_already_shown",
  notificationsPreviousData: "wl_notifications_previous_data",
  notificationsSeen: "wl_notifications_seen_ids"
};
var mockedBasicsKeys = {
  imn: "imn",
  iwt: "iwt"
};
var originTypesToBeAbTested = [
  "serp_full_list" /* FULL_LIST */,
  "serp_map" /* MAP */
];

// src/Utils/api/baseApi.ts
var baseApiWithResponse = async (success, error, options) => {
  return getResponseOrThrowError(options).then(async (response) => {
    const jsonResponse = await response.json();
    const payloadGenericObject = jsonResponse;
    success(payloadGenericObject);
  }).catch((errorResponse) => {
    error(errorResponse);
  });
};
var baseApiWithoutResponse = async (success, error, options) => {
  return getResponseOrThrowError(options).then(() => {
    success();
  }).catch((errorResponse) => {
    error(errorResponse);
  });
};
function delay(millis) {
  return new Promise((resolve) => setTimeout(resolve, millis));
}
var getResponseOrThrowError = async (options) => {
  const { url, httpMethod, body, authenticationToken, retryOnFailure, retryCount, retryDelay, headersOptions } = options;
  const headers = authenticationToken !== void 0 ? {
    "Content-Type": "application/json",
    Authorization: `Bearer ${authenticationToken}`,
    ...headersOptions
  } : {
    "Content-Type": "application/json",
    ...headersOptions
  };
  const fetchInit = {
    method: httpMethod,
    body: JSON.stringify(body),
    headers
  };
  try {
    const response = await fetch(url, fetchInit);
    if (!response.ok) {
      const responseStatusString = response.status.toString();
      if (responseStatusString === "401") {
        throw {
          httpStatusCode: 401,
          errorMessage: "Unauthorized",
          errorCode: "UNAUTHORIZED"
        };
      }
      if (responseStatusString === "301") {
        throw {
          httpStatusCode: 301,
          errorMessage: "Permanently Moved",
          errorCode: "PERMANENTLY_MOVED"
        };
      }
      if (retryOnFailure && retryDelay && retryCount && retryCount >= 0) {
        return delay(retryDelay).then(() => getResponseOrThrowError({ ...options, retryCount: retryCount - 1 }));
      }
      if (responseStatusString.startsWith("5")) {
        throw {
          httpStatusCode: 500,
          errorMessage: "Internal Error",
          errorCode: "INTERNAL_ERROR"
        };
      }
      const responseJson = await response.json();
      if (!responseJson.errors || responseJson.errors.length === 0) {
        throw {
          httpStatusCode: response.status,
          errorMessage: "Unknown error",
          errorCode: "UNKNOWN_ERROR"
        };
      }
      const responseBody = responseJson.errors[0];
      throw {
        httpStatusCode: response.status,
        errorMessage: responseBody.errorMessage,
        propertyName: responseBody.propertyName,
        errorCode: responseBody.errorCode
      };
    }
    return response;
  } catch (error) {
    if (retryOnFailure && retryDelay && retryCount && retryCount >= 0 && error?.httpStatusCode !== 401) {
      return delay(retryDelay).then(() => getResponseOrThrowError({ ...options, retryCount: retryCount - 1 }));
    } else throw error;
  }
};

// src/Utils/api/WL/index.ts
var URL_baseRoute = "/collect-communicate-bff";
var URL_baseFeedbackEndpoint = "/user-feedback-bff";
var URL_addSavedSearch = `${URL_baseRoute}/createUnified`;
var addSavedSearch = async (success, error, options) => {
  const { body, authenticationToken } = options;
  return baseApiWithResponse(success, error, {
    url: URL_addSavedSearch,
    httpMethod: "POST",
    authenticationToken,
    body
  });
};
var URL_addSavedSearchEmail = `${URL_baseRoute}/createUnifiedFromEmail`;
var addSavedSearchEmail = async (success, error, options) => {
  const { body } = options;
  return baseApiWithResponse(success, error, {
    url: URL_addSavedSearchEmail,
    httpMethod: "POST",
    body
  });
};
var URL_getSavedSearches = `${URL_baseRoute}/getAll`;
var getSavedSearches = async (success, error, options) => {
  const { authenticationToken } = options;
  return baseApiWithResponse(success, error, {
    url: URL_getSavedSearches,
    httpMethod: "GET",
    authenticationToken,
    retryOnFailure: true,
    retryCount: REST_RETRY_COUNT,
    retryDelay: REST_RETRY_TIMEOUT
  });
};
var URL_getSavedSearch = `${URL_baseRoute}/get`;
var getSavedSearch = async (success, error, options) => {
  const { id, authenticationToken } = options;
  return baseApiWithResponse(success, error, {
    url: `${URL_getSavedSearch}?id=${id}`,
    httpMethod: "GET",
    authenticationToken,
    retryOnFailure: true,
    retryCount: REST_RETRY_COUNT,
    retryDelay: REST_RETRY_TIMEOUT
  });
};
var URL_updateSavedSearch = `${URL_baseRoute}/update`;
var updateSavedSearch = async (success, error, options) => {
  const { id, authenticationToken, body } = options;
  return baseApiWithResponse(success, error, {
    url: `${URL_updateSavedSearch}?id=${id}`,
    httpMethod: "PUT",
    authenticationToken,
    body
  });
};
var URL_deleteSavedSearch = `${URL_baseRoute}/delete`;
var deleteSavedSearches = async (success, error, options) => {
  const { id, authenticationToken } = options;
  return baseApiWithoutResponse(success, error, {
    url: `${URL_deleteSavedSearch}?id=${id}`,
    httpMethod: "DELETE",
    authenticationToken
  });
};
var URL_updateChannelState = `${URL_baseRoute}/channel`;
var updateChannelState = async (success, error, options) => {
  const { id, authenticationToken, body } = options;
  return baseApiWithoutResponse(success, error, {
    url: `${URL_updateChannelState}?id=${id}`,
    httpMethod: "PUT",
    authenticationToken,
    body
  });
};
var URL_updateRelaxedCriteria = `${URL_baseRoute}/relaxedCriteria`;
var updateAlternativeState = async (success, error, options) => {
  const { id, authenticationToken, value } = options;
  return baseApiWithoutResponse(success, error, {
    url: `${URL_updateRelaxedCriteria}?id=${id}`,
    httpMethod: "PUT",
    authenticationToken,
    body: { enabled: value }
  });
};
var URL_getSavedSearchMatches = `${URL_baseRoute}/getSavedsearchMatches`;
var getSavedSearchMatches = async (success, error, options) => {
  const { authenticationToken, savedSearchId } = options;
  const finaleSuccess = (response) => {
    const finaleResponse = response.map((match) => ({
      ...match,
      matchingContext: {
        ...match.matchingContext,
        matchedAt: new Date(match.matchingContext.matchedAt)
      }
    }));
    success(finaleResponse);
  };
  return baseApiWithResponse(finaleSuccess, error, {
    url: `${URL_getSavedSearchMatches}?id=${savedSearchId}`,
    httpMethod: "GET",
    authenticationToken
  });
};
var URL_getMigrationState = `${URL_baseRoute}/getMigrationState`;
var getMigrationState = async (success, error, options) => {
  const { authenticationToken } = options;
  return baseApiWithResponse(success, error, {
    url: URL_getMigrationState,
    httpMethod: "GET",
    authenticationToken
  });
};
var URL_updateMarketing = `${URL_baseRoute}/optinMarketing`;
var updateMarketing = async (success, error, options) => {
  const { values, email } = options;
  const { optOutMarketing, optInPartners } = values;
  const body = {
    email,
    optInPreferences: [
      !optOutMarketing ? { type: "marketing", channel: "email" } : void 0,
      optInPartners ? { type: "partners", channel: "email" } : void 0
    ].filter(Boolean)
  };
  return baseApiWithoutResponse(success, error, {
    url: URL_updateMarketing,
    httpMethod: "POST",
    body
  });
};
var getQuestionnaire = async (success, error, options) => {
  return baseApiWithResponse(success, error, {
    url: `${URL_baseFeedbackEndpoint}/questionnaire?lang=${options?.lang ?? "en"}`,
    httpMethod: "GET"
  });
};
var postQuestionnaire = async (success, error, options) => {
  const { body, authenticationToken, anonymousToken } = options;
  const authenticatedUrl = `/unsubscribefeedback`;
  const anonymousUrl = `/unsubscribefeedbackbytoken?token=${anonymousToken}`;
  const url = anonymousToken ? anonymousUrl : authenticatedUrl;
  return baseApiWithoutResponse(success, error, {
    url: `${URL_baseFeedbackEndpoint}${url}`,
    httpMethod: "POST",
    authenticationToken,
    body
  });
};

// src/Utils/storage/index.ts
var getLocalStorageItem = (key) => {
  if (!isLocalStorageUndefined()) return localStorage.getItem(key);
  else return null;
};
var setLocalStorageItem = (key, value) => {
  if (!isLocalStorageUndefined()) localStorage.setItem(key, value);
};
var removeLocalStorageItem = (key) => {
  if (!isLocalStorageUndefined()) localStorage.removeItem(key);
};

export { I18N_NAMESPACE, LegacyIWTFeatures, LegacyIWTRelaxMode, REST_RETRY_COUNT, REST_RETRY_TIMEOUT, SavedSearchButtonOrigin, URL_addSavedSearch, URL_addSavedSearchEmail, URL_baseFeedbackEndpoint, URL_baseRoute, URL_deleteSavedSearch, URL_getMigrationState, URL_getSavedSearch, URL_getSavedSearchMatches, URL_getSavedSearches, URL_updateChannelState, URL_updateMarketing, URL_updateRelaxedCriteria, URL_updateSavedSearch, addSavedSearch, addSavedSearchEmail, baseApiWithResponse, baseApiWithoutResponse, createLegacyEndpoint, defaultChannels, deleteSavedSearches, errorCodes, getBrandConfig, getBrandHostname, getCustomBrandConfig, getLocalStorageItem, getMigrationState, getQuestionnaire, getSavedSearch, getSavedSearchMatches, getSavedSearches, intermediaryMatchingMandateLocalStorageKey, intermediaryMatchingMandateLokalizePrefix, intermediaryMatchingMandateTestId, isDocumentUndefined, isLocalStorageUndefined, isSSR, isWindowUndefined, legacyAlternativesOff, legacyAlternativesOn, localKeys, mockedBasicsKeys, originTypesToBeAbTested, postQuestionnaire, removeLocalStorageItem, resources, savedSearchApiErrorCode, savedSearchButtonModalTestId, setLocalStorageItem, updateAlternativeState, updateChannelState, updateMarketing, updateSavedSearch, useLoadTranslations, useTranslation };
//# sourceMappingURL=chunk-DBIF5UGD.mjs.map
//# sourceMappingURL=chunk-DBIF5UGD.mjs.map